import React, { useState } from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import { Animated } from 'react-animated-css'
import ModelVideo from '@/components/ModelVideo'
import play from '@/assets/images/play.png'
import BackIcon from '@/assets/images/back-icon.png'
import Bg1 from '@/assets/images/news/01_bg.jpg'
import Bg1_1 from '@/assets/images/news/01_bg1.png'
import Bg1_2 from '@/assets/images/news/01_bg2.jpeg'

import Bg2 from '@/assets/images/news/02_bg.jpg'
import Bg2_1 from '@/assets/images/news/02_bg1.png'
import Bg2_2 from '@/assets/images/news/02_bg2.png'

import Bg3 from '@/assets/images/news/03_bg.jpg'
import Bg3_1 from '@/assets/images/news/03_bg1.png'
import Bg3_2 from '@/assets/images/news/03_bg2.png'
import Bg3_3 from '@/assets/images/news/03_bg3.png'
import Bg3_4 from '@/assets/images/news/03_bg4.png'

import Bg4 from '@/assets/images/news/04_bg.jpg'
import Bg4_1 from '@/assets/images/news/04_bg1.png'

import Bg5 from '@/assets/images/news/05_bg.jpg'
import Bg5_1 from '@/assets/images/news/05_bg1.png'
import Bg5_2 from '@/assets/images/news/05_bg2.png'
import Bg5_3 from '@/assets/images/news/05_bg3.png'

import Bg6 from '@/assets/images/news/06_bg.jpg'
import Bg6_1 from '@/assets/images/news/06_bg1.png'
import Bg6_2 from '@/assets/images/news/06_bg2.png'
import Bg6_3 from '@/assets/images/news/06_bg3.png'
import Bg6_4 from '@/assets/images/news/06_bg4.png'
import Bg6_5 from '@/assets/images/news/06_bg5.png'
import Bg6_6 from '@/assets/images/news/06_bg6.png'

import Bg7 from '@/assets/images/news/07_bg.jpg'
import Bg7_1 from '@/assets/images/news/07_bg1.png'

import Bg8 from '@/assets/images/news/08_bg.jpg'
import Bg8_1 from '@/assets/images/news/08_bg1.png'
import Bg8_2 from '@/assets/images/news/08_bg2.png'
import Bg8_3 from '@/assets/images/news/08_bg3.png'
import Bg8_4 from '@/assets/images/news/08_bg4.png'
import Bg8_5 from '@/assets/images/news/08_bg5.png'
import Bg8_6 from '@/assets/images/news/08_bg6.png'
import Bg8_7 from '@/assets/images/news/08_bg7.png'
import Bg8_8 from '@/assets/images/news/08_bg8.png'
import Bg8_9 from '@/assets/images/news/08_bg9.png'
import Bg8_10 from '@/assets/images/news/08_bg10.png'
import Bg8_11 from '@/assets/images/news/08_bg11.png'
import Bg8_12 from '@/assets/images/news/08_bg12.png'
import Bg8_13 from '@/assets/images/news/08_bg13.png'

import Bg9 from '@/assets/images/news/09_bg.jpg'
import Bg9_1 from '@/assets/images/news/09_bg1.png'
import Bg9_2 from '@/assets/images/news/09_bg2.png'

import Bg10 from '@/assets/images/news/10_bg.jpg'
import Bg10_1 from '@/assets/images/news/10_bg1.png'
import Bg10_2 from '@/assets/images/news/10_bg2.png'

import Bg11 from '@/assets/images/news/11_bg.jpg'
import Bg11_1 from '@/assets/images/news/11_bg1.png'

import Bg12 from '@/assets/images/news/12_bg.jpg'
import Bg12_1 from '@/assets/images/home/dynamic12.jpg'

import Bg13 from '@/assets/images/news/13_bg.jpg'
import Bg13_1 from '@/assets/images/news/13_bg1.png'
import Bg13_2 from '@/assets/images/news/13_bg2.png'

import Bg14 from '@/assets/images/news/14_bg.jpg'
import Bg14_1 from '@/assets/images/news/14_bg1.png'
import Bg14_4 from '@/assets/images/news/14_bg4.png'
import Bg14_5 from '@/assets/images/news/14_bg5.png'
import Bg14_6 from '@/assets/images/news/14_bg6.png'
import Bg14_7 from '@/assets/images/news/14_bg7.png'
import Bg14_8 from '@/assets/images/news/14_bg8.png'
import Bg14_9 from '@/assets/images/news/14_bg9.png'

import Bg15 from '@/assets/images/news/15_bg.jpg'
import Bg15_2 from '@/assets/images/news/15_bg2.png'
import Bg15_3 from '@/assets/images/news/15_bg3.png'
import Bg15_4 from '@/assets/images/news/15_bg4.png'
import Bg15_5 from '@/assets/images/news/15_bg5.png'
import Bg15_6 from '@/assets/images/news/15_bg6.png'
import Bg15_7 from '@/assets/images/news/15_bg7.png'

import Bg16 from '@/assets/images/news/16_bg.jpg'
import Bg16_1 from '@/assets/images/news/16_bg1.png'
import Bg16_2 from '@/assets/images/news/16_bg2.png'

import Bg17 from '@/assets/images/news/17_bg.jpg'
import Bg17_1 from '@/assets/images/news/17_bg1.png'

import Bg18 from '@/assets/images/news/18_bg.jpg'
import Bg18_1 from '@/assets/images/news/18_bg1.png'
import Bg18_2 from '@/assets/images/news/18_bg2.png'

import Bg19 from '@/assets/images/news/19_bg.jpg'
import Bg19_1 from "@/assets/images/home/dynamic19.jpg"

import Bg20 from '@/assets/images/news/20_bg.jpg'
import Bg20_1 from '@/assets/images/home/dynamic20.jpg'
import Bg20_2 from '@/assets/images/news/20_bg2.jpeg'

import Bg21 from '@/assets/images/news/21_bg.jpg'
import Bg21_1 from '@/assets/images/home/dynamic21.jpg'

import Bg22 from '@/assets/images/news/22_bg.jpg'
import Bg22_1 from '@/assets/images/home/dynamic22.jpg'
import Bg22_2 from '@/assets/images/news/22_bg1.jpeg'
import Bg22_3 from '@/assets/images/news/22_bg2.jpeg'

import Bg23 from '@/assets/images/news/23_bg.jpg'
import Bg23_1 from '@/assets/images/home/dynamic23.jpg'
import Bg23_2 from '@/assets/images/news/23_bg1.jpeg'

import Bg24 from '@/assets/images/news/24_bg.png'
import Bg24_1 from '@/assets/images/home/dynamic24.jpg'
import Bg24_2 from '@/assets/images/news/24_bg1.jpeg'

import Bg25 from '@/assets/images/news/25_bg.jpg'
import Bg25_1 from '@/assets/images/news/25_bg1.png'
import Bg25_2 from '@/assets/images/news/25_bg2.png'
import Bg25_3 from '@/assets/images/news/25_bg3.png'
import Bg25_4 from '@/assets/images/news/25_bg4.png'
import Bg25_5 from '@/assets/images/news/25_bg5.png'
import Bg25_6 from '@/assets/images/news/25_bg6.png'

import Bg26 from '@/assets/images/news/26_bg.jpg'
import Bg26_1 from '@/assets/images/home/dynamic26.jpg'
import Bg26_2 from '@/assets/images/news/26_bg1.png'
import Bg26_3 from '@/assets/images/news/26_bg2.png'
import Bg26_4 from '@/assets/images/news/26_bg3.png'
import Bg26_5 from '@/assets/images/news/26_bg4.png'
import Bg26_6 from '@/assets/images/news/26_bg5.png'
import Bg26_7 from '@/assets/images/news/26_bg6.png'

import Bg27 from '@/assets/images/news/27_bg.jpg'
import Bg27_1 from '@/assets/images/home/dynamic27.jpg'

import Bg28 from '@/assets/images/news/28_bg.jpg'
import Bg28_1 from '@/assets/images/news/28_bg1.png'
import Bg28_2 from '@/assets/images/news/28_bg2.png'
import Bg28_3 from '@/assets/images/news/28_bg3.png'

import Bg29 from '@/assets/images/news/29_bg.jpg'
import Bg29_1 from '@/assets/images/news/29_bg1.png'
import Bg29_2 from '@/assets/images/news/29_bg2.png'
import Bg29_3 from '@/assets/images/news/29_bg3.png'

import Bg30 from '@/assets/images/news/30_bg.png'
import Bg30_1 from '@/assets/images/news/30_bg1.png'
import Bg30_2 from '@/assets/images/news/30_bg2.png'

import Bg31 from '@/assets/images/news/31_bg.jpg'
import Bg31_1 from '@/assets/images/news/31_bg1.png'
import Bg31_2 from '@/assets/images/news/31_bg2.png'
import Bg31_3 from '@/assets/images/news/31_bg3.png'

import Bg32 from '@/assets/images/news/32_bg.jpg'
import Bg32_1 from '@/assets/images/news/32_bg1.png'
import Bg32_2 from '@/assets/images/news/32_bg2.png'
import Bg32_3 from '@/assets/images/news/32_bg3.png'

import Bg33 from '@/assets/images/news/33_bg.jpg'
import Bg33_1 from '@/assets/images/news/33_bg1.png'
import Bg33_2 from '@/assets/images/news/33_bg2.png'

const NewsDetail: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [data, setData] = useState({
    cosKey: 'https://lecturermap-1319224539.cos.ap-beijing.myqcloud.com/dev/public/17115312911133400.mp4'
  })
  const navigate = useNavigate()
  const { source, id } = useParams()

  const handlePage = () => {
    if(source === 'home') {
      navigate('/')
    }else {
      navigate('/about/news')
    }
  }

  const handlePlay = () => {
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const child = () => {
    if(id == 0) {
      return <Detail01 />
    }else if(id == 1) {
      return <Detail02 />
    }else if(id == 2) {
      return <Detail03 />
    }else if(id == 3) {
      return <Detail04 />
    }else if(id == 4) {
      return <Detail05 />
    }else if(id == 5) {
      return <Detail06 />
    }else if(id == 6) {
      return <Detail07 />
    }else if(id == 7) {
      return <Detail08 />
    }else if(id == 8) {
      return <Detail09 />
    }else if(id == 9) {
      return <Detail10 />
    }else if(id == 10) {
      return <Detail11 />
    }else if(id == 11) {
      return <Detail12 />
    }else if(id == 12) {
      return <Detail13 />
    }else if(id == 13) {
      return <Detail14 />
    }else if(id == 14) {
      return <Detail15 />
    }else if(id == 15) {
      return <Detail16 />
    }else if(id == 16) {
      return <Detail17 />
    }else if(id == 17) {
      return <Detail18 />
    }else if(id == 18) {
      return <Detail19 />
    }else if(id == 19) {
      return <Detail20 />
    }else if(id == 20) {
      return <Detail21 />
    }else if(id == 21) {
      return <Detail22 />
    }else if(id == 22) {
      return <Detail23 />
    }else if(id == 23) {
      return <Detail24 />
    }else if(id == 24) {
      return <Detail25 />
    }else if(id == 25) {
      return <Detail26 />
    }else if(id == 26) {
      return <Detail27 />
    }else if(id == 27) {
      return <Detail28 />
    }else if(id == 28) {
      return <Detail29 />
    }else if(id == 29) {
      return <Detail30 />
    }else if(id == 30) {
      return <Detail31 />
    }else if(id == 31) {
      return <Detail32 />
    }else if(id == 32) {
      return <Detail33 />
    }
  }

  return (
    <>
      <main className='header-top'>
        <div className='warp-detail-news home-page'>
          <Animated
            animationIn="bounceInRight"
            animationOut="fadeOut"
            isVisible={true}>
            { child() }
            <div className='go-page' onClick={handlePage}>
              <img src={BackIcon} alt=""/>
              <span>返回上一页</span>
            </div>
          </Animated>
        </div>
      </main>
      <ModelVideo isModalOpen={isModalOpen} handleCancel={handleCancel} data={data} />
    </>
  )
}

export default NewsDetail

const Detail01 = () => {
  return (
    <>
      <div className='detail-news-date'>2024.07.17</div>
      <div className='detail-news-title'>辞旧迎新，未来可7丨熙诚教育投资七周年</div>
      <img className='detail-news-banner' src={Bg1} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          过去7年里，我们种下真诚和专业。 <br />
          此刻，我们收获了朋友和伙伴。 <br />
          熙诚教育投资七周年，我们跟合作伙伴一起庆祝。 <br /> <br />
          <img width='100%' src={Bg1_1} alt=""/>
          图｜熙诚教育投资7周年·战略客户答谢活动
          <br /><br />
          <span className='sub-title'>01、在一起，未来可7</span> <br />
          过去7年，我们跟中国企业一起成长，彼此成就。
          <img width='100%' src={Bg1_2} alt=""/>
          图｜各行业客户齐聚一堂，共话发展 <br /> <br />
          有中国经济发展的压舱石——央企和国企 <br />
          有互联网大厂 <br />
          有传统行业龙头 <br />
          有细分赛道隐形冠军 <br />
          有专精特新的后起之秀 <br />
          …… <br /><br />
          服务过程中，我们力求做到“让每一个客户因我们而精进”，沉淀了诸多有代表性的优秀案例，也更懂中国企业的经营。服务客户的同时，我们也在向客户学习成功的经验，教学相长，熙诚教育投资也因此不断成长和发展。<br />
          过去，我们是向美国、德国、日本等西方国家学习，而今天的很多中国企业，已经走在发展的前沿。我们很难像过去那样，摸着外国企业的经验过河了。去年司庆，我们发起了中国式企业管理典范倡议，希望能扎根于中国企业管理实践，把中国本土内一些具体的、分散的企业管理成果的实践经验不断地条理化、系统化、理论化，构建有中国特色的企业管理知识体系，研究更适合中国企业现状，更适用于当前经济形势的方法。经过了一年的实施与沉淀，我们已经整理汇总了一些具有代表性的“中国式企业管理典范案例”，并将持续努力完成这份事业。 <br />
          教学相长，我们始终跟中国企业在一起。<br /> <br />
          <span className='sub-title'>02、守正创新，未来可7</span> <br />
          再大的企业，再了不起的人物，在某一些时刻都需要思考创新。而现在，大家比过去的任何时刻，都更重视创新，希望通过创新解决新形势下遇到的问题。 <br />
          变局之中，如何创新？ <br />
          我们从很多优秀的企业身上看到了答案：守正创新。 <br />
          行稳智能创始人/CEO翁锋先生，现场就抛出这样一个问题与大家互动： <br />
          “当产品不好卖，老板还要我们交业绩时，我们应该抓什么？” <br />
          翁锋先生的观点是“市场不好的时候，可能得逐渐向管理要业绩”。并通过“过客户”和“半年会定目标”两个常见的场景，表达了自己如何思考和创新。 <br />
          聪明的企业经营者不会盲目的傻创新，守住企业经营管理的本质，是创新的前提。 <br /><br />

          现场，我们通过一个创新剧本杀，跟各位嘉宾一起沉浸式体验，如何解决一个企业经营中最常见的问题：提高组织协同。 <br />
          剧本杀的场景是：企业团建中交通工具发生故障，行政、人资、品牌、业务主管等不同角色如何应对？<br />
          第一轮讨论，每个人都按照自己对角色权责的理解，发表了观点，站在某个角色的立场上。我们发现，人本能地更关注自己，甚至只关注自己。就像在工作场景中，每个部门和岗位，都更优先关注自己的工作内容，这就导致了跨部门沟通和协作中，大家因为立场的不同出现了“部门墙”，甚至淡化了完成这项工作的最终目标。 <br />
          而站在经营者的视角，我们的目标应该是“顺利解决交通工具故障，完成团建”。 <br />
          现场老师做了第二轮引导：强化目标，引导换位思考。 <br />
          各部门开始可以做到目标一致，且“共同看见”，发现问题。内耗减少了，各部门不再是相对独立，大家互溶共进，紧密合作，问题就变得简单了。 <br />
          这其实是企业经营管理中常见的问题：战略目标统一，团队工作协同。我们通过创新的方式提高参与者学习意愿和效果。 <br />
          这也是熙诚教育投资的守正创新。<br />
          守正才能不迷失方向、不犯颠覆性错误，创新才能把握时代、引领时代。<br />
          守正创新，发掘企业内生力量，也许是一切问题的答案。<br /><br />

          <span className='sub-title'>03、自驱进化，未来可7</span><br />

          “多数曾经成功的路径在当前新经济环境下或许不再是最优解，甚至当下的选择会冲击我们过去的决策流程。”<br />
          —— 熙诚教育投资总经理  李越<br />
          今天，中国企业面临的挑战是什么？<br />
          1、企业的绩效可能是由外部因素决定的；<br />
          2、企业自身过去的经验可能不再可复用；<br />
          3、持续的不确定性。<br />

          面对不确定性挑战，企业必须辞旧迎新，不断进化。<br />

          “要解决问题，必须通过计划、组织、领导、协调和控制，最大限度地发挥资源的使用效率，实现资源组合的效率最大化。想要管理更有效，决策效率更高，必须要理清楚组织内部所有个体之间的关系，清楚界定责、权、利，通过职责、制度、流程等方面的设计，定义资源的分配和流转路径，从而实现组织效率的最大化。于是，我们研发了一个咨询项目——帕累托价值再造。”<br /><br />

          越总所讲的咨询项目，是2023年我们萃取真实的企业成功经验，为了协助企业正确理解数字化、结合企业实际的业务场景，从人才与组织的角度做好转型准备，为企业数字化转型提供有力、可落地的抓手，推出了面向数字化转型困境的解决方案《达尔文人才跃迁计划》。同时，继提升组织内“人”发现问题的能力、改善的动力、持续成长的内驱力后，2024年，光合企学再度聚焦“流程”这一重要环节，研发了【帕累托价值再造】咨询项目，通过梳理企业价值创造的流程，对齐各部门工作价值，帮助企业找到隐性增长点，将资源聚向创造价值。<br />
          商业唯一不变的，就是永远处于变局之中。“黑天鹅”和“灰犀牛”事件随着社会、科技、经济、政治环境的发展不断上演。企业告别对过去的路径依赖，聚焦人才和组织的不断进化才能生存和发展。<br />
          活动的最后，李越对在场的客户再次表示诚挚的感谢。我们将继续秉持教学相长的初心，植根于企业学习领域，不断创新和优化。<br />
          我们将跟中国优秀企业一起，坐在世界经济发展的“牌桌上”，展望未来。<br />
        </div>
        {/*<div className='detail-news-video'>*/}
        {/*  <div className='detail-news-mask flex-center' onClick={handlePlay}>*/}
        {/*    <img src={play} alt=""/>*/}
        {/*  </div>*/}
        {/*  <img width='100%' src='https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/cdd8098e8e4743279cf712526594d98f_mergeImage.png'></img>*/}
        {/*</div>*/}
      </div>
    </>
  )
}

const Detail02 = () => {
  return (
    <>
      <div className='detail-news-date'>2024.01.08</div>
      <div className='detail-news-title'>熙诚教育投资积极投身教育公益事业，协办春禾第七期校长研修坊</div>
      <img className='detail-news-banner' src={Bg2} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          1月3日至5日，由上海春禾青少年发展中心主办、熙诚教育投资协办的春禾第七期校长研修坊在北京开展，来自全国各地的春禾项目学校校长30余人参加了研修活动。 <br />
          本期校长研修坊，包括“系统思考领导力”、“校长5E领导力”等多项主题内容，目的是帮助各位校长开阔教育视野、更新教育理念，提升校长领导力，切实落地研究性学习课程，带领学校教育回归培养学生核心素养的教育本真。 <br />
          <img width='100%' src={Bg2_1} alt=""/>
          图｜熙诚教育投资捐赠了“系统思考”相关课程
          <br /><br />
          春禾理事长陆逊重点感谢了熙诚教育投资对本期活动的捐赠：除了为大家提供免费的活动场地及课程服务外，熙诚教育投资还捐赠了“系统思考领导力”主题课程，为教育工作者进行系统性思考的定向能力培养，帮助各位校长以全局视角理解和解决复杂问题，有效面对学校管理中的挑战和困难。随后，陆逊理事长代表春禾，聘请熙诚教育投资总经理李越担任上海春禾青少年发展中心名誉理事。 <br />
          <img width='100%' src={Bg2_2} alt=""/>
          图｜春禾聘请李越担任上海春禾青少年发展中心名誉理事 <br /> <br />
          ‘传递前沿思想’，一直以来都是熙诚教育投资在践行的使命。然而前沿思想的传递是有过程的，在不同节点上，不同的个体和组织也发挥着不同的作用。在此过程中，学校作为一线，先将先进思想传递到‘最前端’，而我们，就扮演着“桥梁”角色，让走出校园迈入企业的人获得更好地成长，承载更多先进的管理理念，最后一起完成人才培养的全生命周期这个伟大事业中去。熙诚教育投资作为一家国有企业，有责任、有担当加入这个事业中去，这也是我们和春禾合作的初衷。”李越表示，接下来，我们会加强与上海春禾青少年发展中心在教育公益领域协作，共同推动核心素养教育的发展，助力乡村教育振兴，构建合作共赢新格局。
        </div>
      </div>
    </>
  )
}

const Detail03 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.12.08</div>
      <div className='detail-news-title'>熙诚教育投资携手北大国发院开展承泽企业家圆桌会，探寻中国品牌成长之路</div>
      <img className='detail-news-banner' src={Bg3} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          2023年，应时代的新变局和企业家的新需求，北大国发院正式推出了【承泽企业家研修班】，重点培养企业家在新变局时代急需的新思维、新能力，助力其开拓事业的新局面，通达人生的新境界。<br />
          为了促进承泽班学员与校友互相融合，构建企业家经验与智慧交流的平台，11月17日，北大国发院承泽企业家研修班开启了第一期圆桌会活动——“探寻中国品牌成长之路”。此次活动由熙诚教育投资作为协办单位提供了执行协助。 <br />
          <img width='100%' src={Bg3_1} alt=""/>
          图｜探寻中国品牌成长之路·大合影
          <br /><br />
          本次活动，经过深度了解案例主企业的背景和需求，熙诚教育投资的教练团队打破了以往私董会仅有企业家互相输入的场景设计，引入业务专家和行业内头部企业的企业家作为补充，提供其它公司遇到同样问题的解法与经验。这种方式一方面保证了案例主企业能获取有效的建议，另一方面建立“借假修真”的模式，将一个具体问题泛化为企业共性的业务发展问题，让每一个参与者都能有更深度的收获，同时也让每一位参与者都见贤思齐，彼此贡献智慧与力量。<br /><br />
          本期私董会案例企业是由承泽企业家学员陈萍和万娟女士共同创立的高端品牌——Thaiv。Thaiv珠宝定位于高净值人群，展现的是珍珠之美。如何把珍珠之美，转变成商业价值，并不断发扬光大是两位案主希望大家探讨的问题。<br /><br />
          活动中，案例主介绍了本企业的发展概况、在经营管理中遇到的主要问题，以及希望通过本次圆桌会活动希望解决的问题。来自不同行业、不同性质企业的听众在专家教练的引导下，通过两轮提问，不断抽丝剥茧，探索品牌价值和核心定位，讨论如何获取及培育核心客户，寻找珠宝企业的国际化路径。在这个过程中案例主明确了自己的3个核心问题，现场企业家们围绕精准客户画像，拓展新客群和复购粘性培育这三个维度，分成3个小组，在组织教练、营销专家以及现场同行业专家的带领下，共同形成了针对案例主企业的有效落地解决方案。<br />
          <img width='100%' src={Bg3_2} alt=""/>
          <img width='100%' src={Bg3_3} alt=""/>
          图｜各小组分别探讨解决方案 <br /> <br />
          在此次活动策划中，熙诚教育投资邀请的专家教练，成为了案例主和听众的“催化剂”，他不断建议案例主以一颗开放的心去聆听所有的建议、意见，同时也引导听众去关注企业的特质以及最关键的诉求。<br /> <br />

          活动结束后，在场的企业家分享了对于此次活动的一些感悟：<br />
          “今天我的收获：了解了一个高端品牌故事，私人定制的匠心品质和长期主义的价值坚持；同时也认识了一批优秀创业者。企业家研修项目各项活动的精雕细琢，体现了国发院精品项目的价值。” <br /><br />
          “整个圆桌会围着主题有序进行，让我看到了一些大家共性的思考模式也看到了很多非常珍贵的视角，整个过程都非常启发深度思考。” <br />
          <img width='100%' src={Bg3_4} alt=""/>
          图｜Thaiv对活动方表示感谢
          <br /><br />
          作为此次活动的协办方，熙诚教育投资未来将继续推进与北京大学国家发展研究院的深度合作，持续为企业家提供解决真实业务问题的解决方案，助力中国式企业管理典范走向世界。
        </div>
      </div>
    </>
  )
}

const Detail04 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.12.05</div>
      <div className='detail-news-title'>荣誉时刻丨熙诚教育投资荣获第15届博奥奖“年度最佳数字化人才赋能服务商”</div>
      <img className='detail-news-banner' src={Bg4} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          上个月，由在线教育资讯网（Online-edu）主办的第15届中国企业数智化学习大会（CEFE）在北京隆重举行，大会结合当下热门的人工智能、数字人、元宇宙以及AIGC等前沿技术在培训场景下的创新与实践话题开展。其中最受瞩目的“博奥奖”颁奖典礼上，熙诚教育投资凭借专业化的课程设计能力和精益求精的创新态度获得“年度最佳数字化人才赋能服务商”。 <br />
          <img width='500px' src={Bg4_1} alt=""/> <br />
          图｜熙诚教育投资荣获博奥奖·年度最佳数字化人才赋能服务商
          <br /><br />
          博奥奖作为“数字化学习行业”的重量级奖项，自2008年首届发起至今，已经累计数千家企业和机构参与申报评选，共沉淀数千个数字化学习及应用的实践案例，评选出的获奖项目对当时的企业培训提供了丰富的思路和可行性方案，为行业的健康发展起到了重要的推动作用。<br /><br />
          熙诚教育投资作为中国咨询培训行业的国企先锋，关注企业人才发展的各个阶段，为企业人才成长路径进行全面赋能。“光合企学”是熙诚教育投资旗下企业学习品牌，在2023年推出了数字化解决方案，从数智洞察、数智解码、数智组织、数智引擎四个模块，为企业培养数字化人才，助力企业数字化转型有效落地。此次获得“年度最佳数字化人才赋能服务商”奖项，充分证明培训行业对光合企学数字化解决方案的高度认可。<br /><br />
          未来，光合企学将继续深耕企业学习领域，以丰富的行业经验沉淀和追求卓越的匠心精神，不断提升产品创新力，持续巩固产品服务实力，做企业成长道路上最值得信赖的伙伴，为客户的健康可持续发展注入强劲能量！
        </div>
      </div>
    </>
  )
}

const Detail05 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.10.25</div>
      <div className='detail-news-title'>成都高新区国资金融局一行莅临熙诚教育投资座谈交流</div>
      <img className='detail-news-banner' src={Bg5} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          10月24日，成都高新区国资金融局党组书记、局长彭涌一行莅临熙诚教育投资指导工作，双方就“资本赋能，共促企业高质量发展”主题进行工作座谈。北京观韬中茂律师事务所、四川桃子健康科技股份有限公司、申万宏源证券承销保荐有限责任公司等领导及相关同志也参加本次座谈。 <br />
          <img width='100%' src={Bg5_1} alt=""/> <br />
          图｜与高新区金融局领导一行进行交流
          <br /><br />
          熙诚教育投资总经理李越对此次到访的成都高新区国资金融局领导、企业代表、金融机构代表表示热烈欢迎，对成都高新区国资金融局对熙诚教育投资的关注表示感谢，并简要介绍了熙诚教育投资发展概况与产业布局。他表示，熙诚教育投资在区域产业规划布局与升级、大中型企业高质量发展与全域生态建设、中小企业持续增长资本赋能等方面，与成都高新区支柱产业拥有广阔合作空间，希望双方能够加强沟通、彼此赋能寻求更多合作机会，共同护航区域企业高质量发展，从容走向资本市场。<br /><br />
          <img width='100%' src={Bg5_2} alt=""/> <br />
          图｜双方交流如何帮助企业走向资本市场
          <br /><br />
          彭涌对熙诚教育投资的热忱接待表示感谢，并介绍了高新区产业发展概况。他表示，本次到访熙诚教育投资，旨在加强双方在各自优势领域的学习，寻求全新合作机会。希望未来双方能够建立联络机制，加强沟通合作，打通资源链路，助力中小企业发展，支持更多企业挂牌融资，开创高新区发展新格局。<br />
          <img width='100%' src={Bg5_3} alt=""/> <br />
          图｜彭涌分享高新区企业发展现状
          <br /><br />
          与会的企业代表及金融机构也积极参与座谈交流，就企业融资、政策扶持、区域产业规划与发展等内容展开讨论。参与座谈的所有嘉宾一致期望，未来能借助区域合作，对各项资源进行重点对接，聚焦互补与高效合作，共同助推高质量发展，实现地方经济社会发展与企业成长壮大的双赢局面。
        </div>
      </div>
    </>
  )
}

const Detail06 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.09.15</div>
      <div className='detail-news-title'>产品为王丨光合企学亮相2023企业教育培训博览会！</div>
      <img className='detail-news-banner' src={Bg6} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img width='100%' src={Bg6_1} alt=""/> <br /><br />
          9月14日至9月15日，新华报业传媒集团《培训》杂志发起的“2023企业教育培训博览会”在深圳大中华喜来登酒店隆重举行。<br /><br />
          光合企学作为企培行业的优秀代表，也受邀参加了此次活动，并与到场的国内外大咖、专业领域专家学者以及优秀企业代表，共同碰撞新思路，交流新实践，探索新发展，共同构建高效对接、精准匹配的资源平台和共生共赢的产业生态，推动中国企业教育培训事业高质量发展。<br /><br />

          <span className='sub-title'>聚焦“人才进阶、组织建设、业务发展”</span><br />
          <span className='sub-title'>——为企业提供定制化解决方案</span><br /><br />

          企业的核心是产品。同样，行业做大做强的核心依然是产品。在当下这个时代，优秀的培训产品，是验证企业培训服务商真正实力的“硬通货”。<br /><br />
          作为《培训》杂志的长期合作伙伴，光合企学亮相2023企业教育培训博览会展区，聚焦企业人才进阶、组织建设、业务发展等内容，重点展示了系统思考、战略解码、高潜培养、数字化解决方案、演进1号位等核心产品，进一步彰显了光合企学为企业提供定制化解决方案的能力。
          <img width='100%' src={Bg6_2} alt=""/> <br /><br />
          受到展示产品的吸引，诸多参会同仁纷纷驻足，与现场工作人员进行沟通洽谈！<br />
          <img width='100%' src={Bg6_3} alt=""/>
          <img width='100%' src={Bg6_4} alt=""/>
          <span className='sub-title'>【高潜人才打造计划】为企业嵌入增长基因</span> <br /><br />
          产业变迁、技术革新与跨界融合正在重塑组织与人的关系，企业的商业模式、组织模式和领导模式也在发生着深刻的变革。面对复杂多变的经济环境，企业的组织和领导力需要更快速、更高效、更灵活地应对和解决来自于企业内外复杂多变的新问题。<br />
          在领导力与组织变革论坛上，熙诚教育投资副总经理张笑妮，以高潜人才打造为例，发表主题演讲，与在场嘉宾深度探讨领导力发展与组织发展领域的创新实践和发展成果，助力中国企业组织与领导力创新成长。<br />
          <img width='100%' src={Bg6_5} alt=""/>
          <img width='100%' src={Bg6_6} alt=""/>
          图｜张笑妮发表高潜人才打造主题演讲 <br /><br />
          “组织应该主动识别和培养所需要的人才，而不是被动地应对人才短缺的情况。” <br /><br />
          据调研，61%的企业领导者认为打造组织的关键人才是首要任务，72%的企业面临高管团队青黄不接的现状。张笑妮认为，不确定时代下，高管人才供应将成为企业永续经营的首要任务。设计高潜人才培养项目时，首先应根据公司战略要求明确高潜人才发展标准，识别可发展人才进入高潜人才池子；其次，根据高潜人才培养标准制定培养计划，紧贴高潜发展路径进行逐层深入辅导提升；最后进行关键评估，建立完善的高潜评估机制与高潜追踪体系。<br />
          光合企学【高潜人才打造计划】更精准、更科学、更高效，从高潜识别到发展演进，再到关键评估，紧密结合企业发展特点，让人才发展潜能转化成绩效，为企业嵌入增长基因，让改变真正发生。 <br />
        </div>
      </div>
    </>
  )
}

const Detail07 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.07.31</div>
      <div className='detail-news-title'>为进一步深化战略合作，熙诚教育投资一行赴雄安新区调研</div>
      <img className='detail-news-banner' src={Bg7} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          在广袤的冀中平原，一幅新时代美好的雄安画卷正快速铺展。今天的雄安，正处在如火如荼的建设进行时，并且轮廓已经越来越清晰。<br /><br />
          7月28日，熙诚教育投资总经理李越、公共事务负责人熊思远一行赴雄安新区调研，就进一步深化战略合作，赋能中小企业高质量发展等内容，与雄安新区管委会相关领导进行深度交流。<br /><br />
          <img width='100%' src={Bg7_1} alt=""/>
          图｜熙诚教育投资一行赴雄安新区调研
          <br /><br />
          当前，世界正处于百年未有之大变局，经济持续承压，对中小企业发展和管理都提出了新的挑战和要求。此时，引领中小企业发展，加速形成优质中小企业铺天盖地的发展格局也是雄安新区义不容辞的责任与使命。<br /><br />
          在2022年，新区先后出台了《关于促进“专精特新”企业和数字经济核心产业高质量发展的若干措施》《关于推进规上工业企业培育发展的四条措施》等一系列政策，助力新区企业的高质量发展。<br /><br />
          下一步，新区将紧盯推动中小企业又好又快发展这一目标，加快构建新区中小企业的“321”工作体系，持续激发中小企业活力。<br /><br />
          调研期间，熙诚教育投资一行详细了解雄安新区整体规划及建设情况，表示将充分发挥自身在企业培训行业优势，为进一步加快雄安新区中小企业发展，提振中小企业发展士气，激发企业发展动能，打造一支高素质人才队伍，实现产业高质量发展贡献一份力量。
         </div>
      </div>
    </>
  )
}

const Detail08 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.07.21</div>
      <div className='detail-news-title'>有为·可为——熙诚教育投资六周年庆圆满落幕</div>
      <img className='detail-news-banner' src={Bg8} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img width='100%' src={Bg8_1} alt=""/> <br />
          向未来，有所为；启新幕，可为之！<br />
          2023年7月20日，“有为·可为——熙诚教育投资六周年庆典”在北京圆满举行。<br /><br /><br />
          <span className='sub-title'>共赴山海篇</span><br /><br />
          作为企业培训行业的国企先锋，六年来，熙诚教育投资始终坚持以实干笃定前行，聚焦中国企业成长，深耕产品与服务，持续突破创新，谋求企业与客户、员工、师资、社会多方的共创共赢，实现了从开创者到引领者的跃迁蜕变，不断打造中国式企业管理新范式。
          <br /><br />
          回顾六年的发展历程，熙诚教育投资在充满不确定性的市场环境中，不断探索与校准，立足于整个行业发展现状，积极开展多元化业务，并借助卓越的资源整合能力和高质量培训服务能力，深度参与到企业的业务和管理中，逐步形成企业学习与咨询培训业务齐头并进、企业人才梯队建设与企业家培养相辅相成、国央企服务和市场化运营互动的事业格局，并在上海、深圳、成都设立了办事处，在全国范围内积极进行业务扩张。此外，熙诚教育投资在保持企业稳健发展的同时，对企业文化进行升级，诠释企业在新时代下的责任与担当，为企业健康发展创造有效路径。
          <br /><br />
          “为世界打造中国式企业管理典范，这个愿景既是熙诚教育投资企业发展的目标，也是我们事业的定位。中国企业飞速发展四十多年，有很多优秀的本土化实践成果。中国企业家在企业管理的过程中，一边立足中国国情，汲取中国传统文化经验与智慧，一边又与时俱进，广泛学习和借鉴外国企业管理的科学理论和实践，不断深化、丰富和创新。这些企业实践的产物，如明珠一般散落各地。所以我们想要打造出中国式企业管理典范，扎根中国企业管理实践，把这些具体的、分散的企业管理成果的实践经验不断地条理化、系统化、理论化，构建出中国自主的企业管理知识体系，助推中国企业健康持续发展。”
          <br /><br />
          庆典现场，熙诚教育投资总经理李越先生发起中国式企业管理典范倡议，并邀请在场嘉宾及社会更多志同道合者参与进来，不断修正对中国式企业管理的理解和定义，构建有中国特色的企业管理知识体系，让中国企业扎根的这片沃土释放出更多的生机与能量。
          <br /><br />
          <img width='100%' src={Bg8_2} alt=""/>
          图｜打造中国式企业管理典范·合作伙伴合影 <br /><br />
          本次活动邀请了来自全国各地多位企业代表、各业界翘楚、业内专家名师参会，各界人士对熙诚教育投资的倡议表示非常认同及支持，纷纷表示愿意为这项伟大的事业贡献力量，并对熙诚教育投资送来了美好的祝福。<br /><br />
          在以中国式现代化全面推进中华民族伟大复兴的新征程上，企业面临艰巨繁重的发展任务和千头万绪的管理课题，熙诚教育投资将以6周年为新契机，在公司发展战略的指引下，以稳健的姿态迎难而上，为广大客户提供更优质的产品与服务，并用乘风破浪的豪情、大有可为创佳绩的激情，做企业成长道路上最值得信赖的伙伴，朝着“为世界打造中国式企业管理典范”这一长期目标奋勇前进！<br /><br />

          <span className='sub-title'>员工欢庆篇</span><br />
          活动当天，全体员工齐聚丽泽SOHO办公区，开启了一场别出心裁的六周年欢快旅程。<br />
          <img width='100%' src={Bg8_3} alt=""/>
          图｜大家在卡通墙互动区，为自己绘制可爱头像 <br />
          <img width='100%' src={Bg8_4} alt=""/>
          <img width='100%' src={Bg8_5} alt=""/>
          图｜大家纷纷与自己的可爱头像合影 <br />
          <img width='100%' src={Bg8_6} alt=""/>
          图｜品牌公关部熊思远为大家介绍企业IP形象-诚端端<br />
          <img width='100%' src={Bg8_7} alt=""/>
          图｜员工展示自己的司庆大礼包，诚端端玩偶深受大家喜欢 <br />
          <img width='100%' src={Bg8_8} alt=""/>
          图｜“诚端端的日常”表情包，在企业微信群里开启了一波刷屏 <br />
          <img width='100%' src={Bg8_9} alt=""/>
          <img width='100%' src={Bg8_10} alt=""/>
          <img width='100%' src={Bg8_11} alt=""/>
          图｜大家高效配合协作，拼出大有可为的熙诚教育投资<br />
          <img width='100%' src={Bg8_12} alt=""/>
          <img width='100%' src={Bg8_13} alt=""/>
          大家把对一年后的自己想说的话，放进专属“时间胶囊”里，期待一年之后，再次站在时间的路口，与现在的自己一起奔赴可期的未来！
        </div>
      </div>
    </>
  )
}

const Detail09 = () => {
  return (
    <>
      <div className='detail-news-date'>2023.06.05</div>
      <div className='detail-news-title'>深化合作丨雄安管委会领导莅临熙诚教育投资指导交流</div>
      <img className='detail-news-banner' src={Bg9} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          2023年6月2日，雄安管委会领导莅临熙诚教育投资指导工作，双方就企业发展话题进行深度交流。 <br />
          <img width='100%' src={Bg9_1} alt=""/>
          图｜雄安管委会领导莅临指导
          <br /><br />
          今天的雄安新区，经过6年规划建设，已进入大规模建设与承接北京非首都功能疏解并重阶段，工作重心已转向高质量建设、高水平管理、高质量疏解发展并举。 <br /><br />
          据了解，当前中央企业在雄安新区设立各类机构140多家，其中二三级子公司90多家；雄安新区“雄才计划”已引进院士及其他高端领军人才12名，选录招聘“双一流”高校人才3000余名，新增各类创新创业人才2.5万余名。此时，如何让新人才在雄安生根、发芽，如何更好地为入驻企业高质量发展提供助力，成为雄安新区未来重点研究的一个课题。针对此项课题，熙诚教育投资与雄安管委会进行了深度探讨，并围绕“人才管理”和“企业高质量发展”形成了初步成果。<br /><br />
          熙诚教育投资作为中国咨询培训行业的国企先锋，旗下拥有的“光合企学”、“演进1号位”和“知识管理局”三大业务品牌，为区域产业规划布局与升级、大中型企业高质量发展与全域生态建设、中小企业持续增长等，提供系统化解决方案与资源整合支持。尤其是聚焦中小企业健康可持续发展的“演进1号位”，重点关注中小企业高层次人才培训与发展，聚合资源打造培、产、融三位一体服务机制，推动咨询培训专业服务的体系化建设，促进中国中小企业现代化治理体系建设。<br /><br />
          <img width='100%' src={Bg9_2} alt=""/>
          图｜雄安管委会领导参观办公区域并合影 <br /> <br />
          雄安管委会领导参观了熙诚教育投资办公区，对我司企业发展、文化建设等方面有了进一步了解。双方还就企业治理、产业项目服务、产融对接等其它课题进行了深入交流。
        </div>
      </div>
    </>
  )
}


const Detail10 = () => {
  return (
    <>
      <div className='detail-news-date'>2024.09.26</div>
      <div className='detail-news-title'>荣誉时刻|熙诚教育投资荣获第七届年度经济大会“2024中国（行业）创新品牌100强”奖项</div>
      <img className='detail-news-banner'  src={Bg10} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          凝心聚力同奋进，群贤毕至谋发展，9月26日，2024（第七届）年度经济大会在北京隆重举行。大会以“新质生产力引领经济高质量发展”为主题，吸引了来自政府、企业、学术界等众多领域的精英代表共襄盛举。北京熙诚教育投资有限公司作为企业咨询培训领域的国企先锋，受邀出席了此次盛会，并获得“2024中国（行业）创新品牌100强”荣誉奖项。 <br />
          <img width={'100%'} src={Bg10_1} alt=""/> <br /><br />
          大会现场，政商产学研各界嘉宾齐聚一堂，聚焦发展前沿，解读政策趋势，交流创新思考，共绘发展图景，携手共进不断开辟高质量发展新领域、新赛道，为全面推进中国式现代化建设贡献智慧与力量。熙诚教育投资近几年在产品开发、市场拓展和品牌建设等方面取得的显著成就，赢得了与会嘉宾的高度评价。并且凭借其在企业咨询培训领域的卓越表现，荣获了大会颁发的“2024中国（行业）创新品牌100强”奖项。该荣誉不仅是对熙诚教育投资过去所获成绩的肯定，更是对未来发展的期许与鼓励。
          <br />
          <img  width={'100%'} src={Bg10_2} alt=""/> <br />
          此次出席2024（第七届）年度经济大会，熙诚教育投资再次向业界展现了其行业影响力和品牌实力。公司表示，将以此次大会为契机，进一步加强与各界的交流与合作，共同推动经济高质量发展。 <br /><br />
          展望未来，熙诚教育投资将继续以市场需求为导向，以产品创新为驱动，不断提升企业核心竞争力和品牌影响力。同时，公司还将积极践行国有企业的责任和担当，向“新”发力，锚定方向，以“质”致远，在推进中国式现代化新征程上，朝着“为世界打造中国式企业管理典范”这一长期目标不动摇，厚植新质生产力的生长土壤，为中国经济的高质量发展贡献一份力量。
        </div>
      </div>
    </>
  )
}


const Detail11 = () => {
  return (
    <>
      <div className='detail-news-date'>2024.09.10</div>
      <div className='detail-news-title'>荣誉时刻|熙诚教育投资荣获第三届T20培训咨询行业企业家论坛“最佳合作潜力奖</div>
      <img className='detail-news-banner' src={Bg11} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          9月9日至９月10日，由T20培训机构董事长俱乐部主办的“创新破局·逆势增长：弘扬企业家精神 聚焦高质量发展” ——2024第三届T20培训咨询行业企业家论坛暨结构思考力10周年生态合作大会在北京成功举办。北京熙诚教育投资有限公司受邀参与论坛并荣获【最佳合作潜力奖】。 <br />
          <img src={Bg11_1} alt=""/><br />
          图｜熙诚教育投资荣获【最佳合作潜力奖】 <br /><br />
          本次论坛专注揭示“破局创新、逆势增长”的底层逻辑，熙诚教育投资与来自各个机构、单位的专家、学者、企业家创始人、行业领军人物协同共进，深度交流，积极探索培训咨询机构利润增长新路径，为推动中国培训咨询行业高质量发展贡献一份力量。 <br /><br />
          在变革与机遇并存的2024年，企业培训，始终是件难而正确的事，愈是艰难时期，愈发考验组织能力。面对市场层层挑战，熙诚教育投资从未停止前进的脚步，不断打磨升级产品能力，在领导力培养、系统思考、高潜人才培养、财务团队赋能、企业数字化转型解决方案等企业学习细分领域重点发力，开发多款自研产品，并打造讲师地图，不断提升企业竞争力。 <br /><br />
          我们通过培训与咨询服务相结合的方式，目前已经服务了300多家企业，沉淀了诸多有代表性的优秀客户案例，也逐渐做到了“让每一个客户因我们而精进”。我们的客户主要集中在金融、科技、医药等行业，其中包括多家知名企业，如：字节跳动、腾讯、阿里、百度、中国结算、中信建投、国家开发银行、泰康养老、国家电投、北京银行、华润双鹤、农夫山泉、一汽大众、中建集团等，累计服务超过20000名企业学员。<br /><br />
          随着AI技术的不断迭代升级，培训行业必然将会迎来更大的发展机遇。熙诚教育投资将坚持行业化深耕，与各行业组织深度共创，快速升级迭代、革新产品能力，锻造智能、高效、敏捷、专业的“产品力”，赋能客户业务快速发展，帮助客户解决实打实的经营问题，助力中国企业高质量发展。
        </div>
      </div>
    </>
  )
}

const Detail12 = () => {
  return (
    <>
      <div className='detail-news-date'>2024.11.15</div>
      <div className='detail-news-title'>熙诚教育投资亮相第13届培博会，斩获2024培博会·培英奖“新锐品牌TOP10”</div>
      <img className='detail-news-banner' src={Bg12} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          11月15日，2024培博会·培英奖重磅出炉，熙诚教育投资凭借专业实力与年度卓越表现，在众多企培机构中脱颖而出，荣获2024培博会·培英奖“新锐品牌TOP10”。<br /><br />
          2024 年，是充满挑战与机遇的一年，企业在高质量发展之路上稳健前行。在此背景下，企业培训行业作为企业成长的关键助力，地位举足轻重。<br /><br />
          作为国内综合实力和影响力突出的大规模教育培训类展览会，培博会被誉为“中国培训业发展风向标”之一。培博会・培英奖作为由培博会发起的专业性奖项，具有极高的行业影响力。它旨在挖掘企业培训行业中具有引领意义的优秀品牌和创新模式，表彰行业的先行者和贡献者，推动优秀实践经验及前沿模式在行业内广泛传播，引领行业健康、快速、有序发展。<br /><br />
          在本届培博会上，熙诚教育投资不仅展示了其在企业咨询及培训领域的最新成果和创新产品，还与众多行业同仁进行了深入交流和合作探讨。熙诚教育投资凭借其深度的行业理解能力、专业化的课程设计能力和卓越的资源整合能力，赢得了业内广泛赞誉和认可。此次荣获培英奖“新锐品牌TOP10”，是对熙诚教育投资在企培行业领先地位的肯定和鼓励。<br /><br />
          展会期间，熙诚教育投资的展位成为众多参观者驻足咨询与体验的热门地点。熙诚教育投资的专业讲师团队耐心细致地回答了参观者提出的各种问题，全面而深入地介绍了公司提供的培训课程与优质服务，分享了最新的行业发展趋势，并针对企业发展中的实际问题给予强落地的指导性建议。<br /><br />
          此次活动的成功举办，为企培行业搭建了一个交流合作的重要平台，也激励更多企培机构以创新为驱动、以质量为根本，拓宽行业发展新思路与新方法。熙诚教育投资作为参展商和获奖者之一，也将不忘初心，继续朝着“为世界打造中国式企业管理典范”的目标，持续提供高质量培训产品和服务，共同推动企培行业健康发展，为中国企业人才培养和经济发展做出贡献。<br /><br />
         <div className='flex-center'>
           <img src={Bg12_1} alt=""/><br />
         </div>
        </div>
      </div>
    </>
  )
}

const Detail13 = () => {
  return (
    <>
      <div className='detail-news-date'>2024-2025</div>
      <div className='detail-news-title'>喜报！熙诚教育投资获“2024-2025最受企业欢迎培训机构”大奖</div>
      <img className='detail-news-banner' src={Bg13} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          日前，由《培训》杂志主办的第十二届中国企业教育培训服务会展圆满落幕，熙诚教育投资凭借深厚的行业积累与创新实力，从众多供应商中脱颖而出，荣膺现场“2024-2025最受企业欢迎培训机构”大奖。<br /><br />
          <img src={Bg13_1} alt="" width={'100%'}/><br />
          图｜熙诚教育投资被评选为“2024-2025最受企业欢迎培训机构”<br /><br />
          2024-2025最受企业欢迎的培训机构榜单，是《培训》杂志历时2个月，调研和访问了200多家具有代表性的企业评出的，熙诚教育投资能脱颖而出并评选获奖，是对公司的莫大鼓励，这代表着客户的认可，未来我们也将秉持专业、创新和值得信赖的初心，为企业提供更优质的人才培养服务。<br /><br />
          <img src={Bg13_2} alt=""/><br />
          企业的核心是产品。在当下这个时代，优秀的培训产品，是验证企业培训服务商真正实力的“硬通货”。作为《培训》杂志的长期合作伙伴，我们这些年来，关注企业人才发展的各个阶段，为企业人才成长路径进行全面赋能。重点聚焦企业人才进阶、组织建设、业务发展等内容，开发了系统思考、高潜培养、企业定制参访、财赋+、达尔文人才跃迁计划等核心产品，进一步彰显了我们为企业提供定制化解决方案的能力。<br /><br />
          未来，我们将继续深耕企业学习领域，以丰富的行业经验沉淀和追求卓越的匠心精神，不断提升产品创新力，持续巩固产品服务实力，做企业成长道路上最值得信赖的伙伴，为客户的健康可持续发展注入强劲能量！
        </div>
      </div>
    </>
  )
}

const Detail14 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.02.25</div>
      <div className='detail-news-title'>焕新·共赢｜熙诚教育投资与金座公司共建非遗文化研学新生态</div>
      <img className='detail-news-banner' src={Bg14} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          在文化自信的时代浪潮中，老字号企业的文化传承与创新发展成为时代的重要课题。2025年2月19日，熙诚教育投资与金座公司一同探讨“教育培训与非遗研学合作交流”，以培训和研学为载体，传承老字号文化基因，书写“文化自信”的时代注脚。作为企业咨询与培训创新生态的深耕者，熙诚教育投资正以“企业咨询与培训赋能产业，文化滋养商业”的独特模式，为非遗传承开辟新路径。<br /><br />
          <strong style={{fontSize: '20px'}}>破界融合：架起文化传承的薪火之桥</strong><br />
          活动现场，熙诚教育投资副总经理张笑妮、研学事业部负责人张楠楠出席本次活动，并介绍了熙诚教育作为国有企业智库平台，我们始终为企业高质量发展创造有效的路径，将先进的前沿思想与成功经验融入到企业管理实践中，帮助企业制定清晰的发展战略，提升战略执行效率，通过优化组织效能、建设人才梯队、强化团队能力、助力企业实现可持续健康发展与卓越绩效提升。
          “研学作为「活态传承」的创新载体，通过构建沉浸式、体验式、参与式的文化传播场景，正在为非遗传承的价值实现开辟出多维路径。我们也在构建‘文化解码－商业赋能－人才培育’三位一体的服务体系，让非遗是可感知、可参与、可传承的活态文化。” 熙诚教育投资研学事业部负责人张楠楠在活动中阐述了公司促进老字号企业文化传承与商业发展的实践路径。同时，金座公司纪委书记肖琳娜详细介绍了系统内老字号企业的相关情况以及公司助力老字号企业文化、经济发展的重点举措中具象呈现，本着合作共赢1+1>2的协同效应，双方就非遗研学、培训合作等方面达成共识，促进了优质教育资源与非遗研学项目的精准有效对接。<br />
          <img src={Bg14_1} alt="" /><br /><br />
          <strong style={{fontSize: '20px'}}>创新转化：让非遗技艺叩响时代大门</strong><br />
          在交流环节，熙诚教育投资副总经理张笑妮提到，熙诚教育投资还将积极探索更多可教学、可体验、可传播、可沉淀的知识载体，为实现老字号企业从文化资产到经济价值的转化。<br /><br />
          活动现场，瑞蚨祥、内联升、德寿堂三家老字号企业相关负责人详细介绍了企业的发展历程、非遗文化传承工作的主要成果，重点介绍了企业非遗体验项目以及非遗技艺与品牌融合的创新实践。<br />
          <img src={Bg14} alt="" width={'100%'}/><br /><br />
          <strong style={{fontSize: '20px'}}>生态共建：编织文化传承的研学经纬</strong><br />
          熙诚教育投资特别提出“教育即传承”的价值主张，通过将企业培训与非遗研学深度融合，既为企业培育“懂文化、精技艺、善创新”的复合型人才，让非遗技艺在商业实践中获得新生。正如内联升非遗传承人在交流中所言：“一针一线里不仅有祖辈的智慧，更蕴含着通向未来的文化密码。”<br />
          <img src={Bg14_4} alt="" width={'100%'} /><br /><br />
          <strong style={{fontSize: '20px'}}>向新而行：咨询与培训企业的文化担当</strong><br />
          这场传统与现代的对话，印证了熙诚教育投资“为世界打造中国式企业管理典范”的使命。当德寿堂古法药香与现代教育理念相遇，当传统技艺邂逅数字技术，我们看到的不仅是非遗的焕新，更是一个企业咨询与培训品牌对文化传承的深层思考——真正的商业向善，在于让文化传承成为可延续的生态，让教育成为文明赓续的永恒火种。<br />
          <img src={Bg14_5} alt=""  width={'100%'} /><br /><br />
          未来，熙诚教育投资将持续为企业提供定制化服务，助力企业提升核心竞争力，为文化强国建设注入生生不息的创新动能，实现文化传承与商业发展的双赢。<br /><br />
          <img src={Bg14_6} alt="" /><br />
          <img src={Bg14_7} alt="" /><br />
          <img src={Bg14_8} alt="" /><br />
          <img src={Bg14_9} alt="" /><br />
        </div>
      </div>
    </>
  )
}


const Detail15 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.02.28</div>
      <div className='detail-news-title'>锻造中流砥柱｜熙诚教育投资携手菜百股份启动“金色工程—金色纽带”，解码核心管理者赋能新范式</div>
      <img className='detail-news-banner' src={Bg15} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          人工智能浪潮席卷全球，企业竞争正从“战略之争”转向“组织基因之战”。中层管理者作为战略落地的“关键传动轴”，其能力水平直接影响企业从基因到表达的完整闭环。熙诚教育投资与菜百股份再度深化战略合作，正式启动“金色工程”2025年首期项目——“金色纽带”人才培养体系项目，以科学化、体系化的培养模式，为中国黄金珠宝行业领军企业锻造新时代中坚力量。<br />
          <img src={Bg15} alt="" width={'100%'}/><br />
          <img src={Bg15_2} alt="" width={'100%'}/><br /><br />
          <strong style={{fontSize: '20px'}}>深耕：从战略解码到人才赋能的携手同行</strong><br />
          在开班仪式上，熙诚教育投资总经理李越，回顾了双方紧密携手、共同打造“金色工程”的历程。作为西城区国有企业智库标杆，熙诚教育投资与菜百股份的合作已走过三年征程。从“金色传承”高管战略赋能项目，到今日“金色工程—金色纽带”人才培养项目，双方始终以 “组织基因进化”为锚点，深度融合企业战略与文化内核：<br />
          深度洞察：通过高管访谈与业务沙盘推演，精准绘制菜百股份“战略-文化-能力”三维人才地图<br />
          体系共建：基于“业务护城河+组织免疫力”双维模型，定制“高管-中层-基层”梯次培养生态<br />
          数字赋能：依托熙诚教育投资“四维关键评估”（四维指，个人基础数据、项目积分表现、测评及考核情况、行为观察报告）及“五线融合（五线指，内容线、行动线、体验线、服务线、效果线）保障系统”，科学观察，量化结果，实现培训效果与项目指标的强关联可视化。<br />
          <img src={Bg15_3} alt="" width={'100%'}/><br /><br />
          <strong style={{fontSize: '20px'}}>创新：双轨制锻造“黄金中坚”</strong><br />
          “金色工程—金色纽带”项目直击核心管理者“战略传导断层”“团队成长断代”等共性痛点，首创“管理能力+业务视野”双轨赋能体系，并以系统课程、实战演练及动态评估体系，为菜百股份锻造兼具领导力与经营思维的中坚力量，构建学习型组织，应对产业变革挑战，助推企业可持续竞争力。管理赋能聚焦领导力跃升与组织进化力建设，涵盖团队管理、团队凝聚力与目标达成、教练式辅导等实战模块，着力推动跨部门协同；业务突破聚焦会员体系的深化与应用、门店盈亏模型搭建与考核模型等8个课题，通过行动学习将业务问题转化为具体业务突破点，通过“学-练-战-评”四维闭环，确保能力提升直击业务痛点。<br />
          此次“金色纽带”的35位学员，都是各部门层层选拔的优秀干部，他们是从561名学员当中，经过3轮选拔的佼佼者。开班仪式上，菜百股份党委书记、董事长谢华萍对这35位学员提出了殷切期望：国企干部需牢记使命，坚守政治原则，传承实干精神，融合创新思维。要提升战略执行、协同创新和数智化实战能力，应对行业挑战。同时，坚持终身学习，“做‘价值坚守’的践行者，做‘知行合一’的奋斗者，做‘薪火相传’的播种者”，并带领团队进步，助力企业发展。<br />
          <img src={Bg15_4} alt="" width={'100%'}/><br /><br />
          <strong style={{fontSize: '20px'}}>护航：全周期陪伴式成长体系</strong><br />
          熙诚教育投资为项目配备 “三位一体”护航机制：<br />
          智库导师团：由熙诚教育提供商业实战派讲师，同时赋能菜百股份8位业务专家为内部导师，引用内外双导师阵容<br />
          动态科学评估：实时追踪学员学习效果，设计高频高互动的学习环节，让学员保持学习热情，同时设计淘汰出库机制，让人才池滚动起来。<br />
          长效运营引擎：搭建“金色工程”项目知识库，沉淀企业智慧资产。<br />
          <img src={Bg15_5} alt="" width={'100%'}/><br />
          “通过 ‘金色工程’ 人才培养体系的精心打造，能够在菜百内部形成良好的人才循环机制，进而推动整个组织向着更可持续、更有竞争力不断迈进。”熙诚教育投资总经理李越在开班仪式发言结尾对项目提出了殷切期望。
          菜百股份党委书记、董事长谢华萍在开班仪式上，也对菜百人提出了新的期待：“菜百股份的‘金色工程’为大家提供了成长机会，也是考验大家责任与使命的平台。希望大家以此次项目为新起点，把个人理想融入企业发展，将学习成果转化为工作动力，在建设‘长寿企业-百年菜百’的道路上，交出一份满意的答卷！”<br /><br />
          <strong style={{fontSize: '20px'}}>愿景：定义中国式管理新范式</strong><br />
          在AI重塑商业逻辑的今天，熙诚教育投资始终坚信：真正抗周期的人才培养体系，必须根植于企业独特的“组织DNA”。我们期待以“金色工程”为蓝本，助力更多中国企业：<br />
          构建战略-人才-文化的共生进化系统<br />
          培育既懂战场、又建城墙的中坚力量<br />
          将管理经验转化为可复制的组织智慧<br /><br />
          <img src={Bg15_6} alt="" width={'50%'} />
          <img src={Bg15_7} alt="" width={'50%'} />
        </div>
      </div>
    </>
  )
}

const Detail16 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.03.21</div>
      <div className='detail-news-title'>熙诚教育投资助力张一元：以人才破局之势，擘画百年老字号焕新蓝图</div>
      <img className='detail-news-banner' src={Bg16} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          春意盎然时节，张一元2025年管理岗位竞聘工作圆满收官。在熙诚教育投资的深度参与下，此次竞聘依托科学测评体系与严谨选拔机制，紧密围绕“双提升”工程要求，积极响应党的二十大精神，成功选拔出一支集“战略型、专业型、创新型、实干型”于一体的复合型管理团队，为百年老字号张一元的高质量发展增添强劲动力。<br /><br />
          <strong style={{fontSize: '20px'}}>破局之道：三大环节搭建人才“高速路”</strong><br />
          自张一元管理岗位竞聘工作启动，在企业内部引发热烈反响。共有 119 名来自不同岗位、不同职务的员工踊跃报名，经严格资格审查后进入人才储备池。竞聘工作突出“能者上、优者胜”，始终坚守公平公正公开、任人唯贤及综合考量原则，竞聘人员需历经层层严格选拔流程，以确保实现精准人岗适配。​
          作为战略合作伙伴，熙诚教育投资依据 “潜能 + 知识 + 技能” 三大科学评估维度，为张一元量身打造契合国企发展需求的人才选拔体系，开辟国企竞聘创新路径。在潜能特质测评环节，借专业心理量表洞察竞聘者领导力倾向、创新思维潜力；线下综合笔试聚焦管理专业知识、业务场景分析、逻辑思维能力，以科学分值考查综合素养；结构性面试环节，由业务高管、行业专家、HRBP 组成评审团，通过案例研讨、情景模拟、压力问答等多种评估手段，系统考察人才在核心胜任力指标上的深度表现。
          这支汇聚战略谋划、专业精研、创新开拓、实干笃行特质的管理队伍，将为强化张一元战略承接能力、提升创新驱动效能、优化跨部门协同水平筑牢坚实人才根基。<br />
          <img src={Bg16_1} alt="" width={'100%'}/><br /><br />
          <strong style={{fontSize: '20px'}}>转型之基：三大举措助力国企人才选拔进阶</strong><br />
          此次张一元管理岗位竞聘，有力推动企业组织能力提升。熙诚教育投资依托三大务实举措，助力张一元打造优质人才队伍。<br />
          <strong>举措一：标准确立：构建岗位胜任体系</strong><br />
          熙诚教育投资依据行业研究与企业实情，为张一元关键岗位搭建精准能力标准，为人才选拔、培育提供科学参照。<br />
          <strong>举措二：数据沉淀：沉淀人才关键信息</strong><br />
          深入分析大量行为数据，为竞聘者生成涵盖能力、潜力的人才数据库，为后续人才任用提供有力数据支撑。<br />
          <strong>举措三：机制创新：打造人才培育任用闭环</strong><br />
          创新设计契合实际的人才任用流程，配套严谨的评估机制，形成 “选拔－任用－评估” 的闭环管理模式，为国企人才选拔工作提供参考范例。<br /><br />
          <strong style={{fontSize: '20px'}}>领航之志：双向奔赴开启高质量发展新征程</strong><br />
          在竞聘总结大会上，张一元党支部书记、董事长霍文斌指出，新部门是新竹，老部门是根基。要突出“先立后破”，在传承与创新中实现动能转换。这与熙诚教育投资“专业赋能组织进化”的理念高度契合。<br />
          <img src={Bg16_2} alt="" width={'600px'}/>
        </div>
      </div>
    </>
  )
}

const Detail17 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.05.21</div>
      <div className='detail-news-title'>熙诚教育投资 × 腾讯云 | 构建智能知识中枢，赋能咨询服务效率跃升</div>
      <img className='detail-news-banner' src={Bg17} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          在行业转型深化与市场竞争加剧的双重挑战下，作为中国咨询培训行业的国企先锋，熙诚教育投资始终以创新驱动发展，聚焦企业管理咨询与学习服务的核心竞争力提升。针对传统顾问个人能力工作模式中知识调用低效、方案质量波动、经验传承滞后等痛点，公司携手腾讯云重磅推出「智能知识中枢」，以科技赋能实现咨询服务效率与品质的双重突破。<br /><br />
          <strong style={{fontSize: '20px'}}>痛点破局：传统模式升级迫在眉睫</strong><br />
          洞察行业共性难题：<br />
          知识调用低效：跨区域、跨部门资料散落于多方渠道，人工检索耗时耗力，完整资料收集常需 1 天以上；<br />
          方案质量波动：新员工因行业认知不足易致资源错配、服务失误等风险频发；<br />
          经验传承滞后：历史案例仅靠口耳相传，新员工难以及时汲取教训，同类问题频频发生。<br />
          破解「人效瓶颈」，成为熙诚教育投资践行国企创新担当的核心课题。<br /><br />
          破局之道，在于以数字化手段重构知识管理体系。<br /><br />
          <strong style={{fontSize: '20px'}}>数智创新：三大突破构建核心竞争力</strong><br />
          依托腾讯云技术能力，熙诚教育投资「智能知识中枢」实现三大关键革新：<br />
          1.智能生成提效：通过腾讯云 TI 平台训练垂直领域模型（如组织变革咨询知识图谱），整合超百份历史标杆方案，提炼通用模块，助力一线团队数小时内完成方案框架搭建，较传统模式提效 80% 以上。<br />
          2.质量审校体系：运用 AI 内容审核技术强化数据合规管控，建立多维度评估机制，自动识别内容短板，确保方案专业性与完整性，筑牢服务质量底线。<br />
          3.经验传承机制：系统沉淀 TOP 顾问方法论，提供场景化学习材料，新员工可快速掌握行业洞察与风险应对策略，能力成长周期缩短 50%。<br />
          <img src={Bg17_1} alt="" width={'100%'} /><br />
          [AI 生成方案示例图]<br /><br />
          <strong style={{fontSize: '20px'}}>实效凸显：四大升级见证转型成果</strong><br />
          系统内测阶段，熙诚教育投资已收获显著成效：<br />
          效率跃升：方案制作支持时间从「天级」压缩至「小时级」，重复性编辑工作耗时从小时级降至分钟级；<br />
          安全升级：智能工作流替代人工授权流程，精准匹配项目所需信息，实现数据安全与协作效率的动态平衡；<br />
          知识资产活化：整合项目方案、行业报告等知识资产，支持结构化检索与智能匹配，告别「人工回忆 + 文件传输」的低效模式；<br />
          人才培养：通过「思维链」展示历史项目风险应对策略，加速「学习 - 应用 - 反馈」闭环，助力团队专业化成长。<br /><br />
          <strong style={{fontSize: '20px'}}>未来展望：深化数智融合，践行国企担当</strong><br />
          面向未来，熙诚教育投资将以「智能知识中枢」为基座，进一步构建方案生成质量管控体系，提升智能生成成果的可靠性；同时建立用户行为数据动态采集机制， 精准匹配细分场景需求，持续优化服务体验。<br />
          作为国企数字化转型的践行者，熙诚教育投资将始终以科技赋能产业升级为己任，通过「智能知识中枢」的深度应用，为客户提供更精准、高效的数智化解决方案，助力中国企业在高质量发展征程中实现战略落地与创新突破。<br /><br />
          从「人力驱动」到「数智驱动」，熙诚教育投资以国企担当书写数字化转型答卷。未来，我们将继续深耕技术与业务融合，以知识管理创新引领行业升级，为中国企业的高质量发展贡献更多智慧与力量！
        </div>
      </div>
    </>
  )
}

const Detail18 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.06.11</div>
      <div className='detail-news-title'>熙诚教育投资入选成都市中小企业数字化转型服务商</div>
      <img className='detail-news-banner' src={Bg18} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img src={Bg18_1} alt="" width={'100%'}/><br />
          <img src={Bg18_2} alt="" width={'100%'}/><br />
          为落实《财政部 工业和信息化部关于开展中小企业数字化转型城市试点工作的通知》(财建〔2023〕117号)文件要求，进一步推进成都市中小企业数字化转型城市试点工作，近日，成都市经济和信息化局组织开展了成都市中小企业数字化转型服务商遴选工作。经企业申报、区（市）县推荐、专家评审、公示确认等程序，北京熙诚教育投资有限公司凭借卓越实力成功入选成都市中小企业数字化转型综合服务商！<br /><br />
          组织方要求申报单位应具备较强本地数字化转型服务能力。技术研发基础好，有行业咨询、诊断、改造的实践经验、稳定团队和成熟产品(有典型应用案例支撑)，且有在成都市内开展业务的条件和能力，能够持续稳定提供高质量服务。本次入选，是对我们多年来服务中小企业数字化转型方面积累的经验及能力的充分肯定，也是对我们在数字化转型领域持续创新和卓越服务的认可，更是对公司在成都区域积极开展业务、为更多成都企业业务赋能的鼓励。<br /><br />
          进入数字时代，企业数字化转型已经不再是一道选择题，而是必答题，这是顺应产业升级的客观需要，是企业提质增效的必经之路。但是部分中小企业在数字化转型过程中仍有阻碍，“不会转、不敢转、不想转”已成为制约中小企业数字化转型的共性问题。<br /><br />
          我们作为中国咨询培训行业的国企先锋，依托于产品的不断打磨与业务实践，多年来，持续为区域产业规划布局与升级、大中型企业高质量发展与全域生态建设、中小企业持续增长等，提供系统化解决方案与资源整合支持，精准“把脉”查明问题，为企业答疑解惑助力企业高质量发展。在2023年，我们萃取了多家成功实现数字化转型的企业经验，针对中小企业数字化转型困境，提炼出“数字化转型金三角”模型，从“人-流程-数据”三要素为企业数字化转型提供可落地的抓手。先后推出了《达尔文人才跃迁计划》、《帕累托价值再造》等一系列“小快轻准” 的数字化产品和解决方案 。这些数字化服务产品，深度契合《成都市支持中小企业数字化转型城市试点若干政策措施》中对优质数字化服务商要求。<br /><br />
          关于“奋力打造全国中小企业数字化转型样板城市”，成都市财政安排了2亿元专项配套资金，用“真金白银”来支持企业数字化转型。其中，对参与诊断并实施数字化转型改造达到标准的企业，每户最高4万元诊断费用全额补助，对完成数字化改造并达标的企业，按照改造投资的50%给予最高100万元的资金补助。如此高的政策补助比例和政府支持力度，让我们看到了成都市政府支持中小企业数字化转型的决心。在此，我们也呼吁有数字化转型需求的中小企业，抓住机遇，积极响应政策走向“提质增效”的转型之路，我们也将响应国家关于中小企业数字化转型的号召，充分发挥自身优势，以更具聚焦“人效提升”的数字化创新产品和服务，通过与政府、企业和社会各界的紧密合作，为中小企业的数字化转型和高质量发展贡献力量。
        </div>
      </div>
    </>
  )
}

const Detail19 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.06.24</div>
      <div className='detail-news-title'>“AI+ ”走进西城企联，DeepSeek助力企业办公提效</div>
      <img className='detail-news-banner' src={Bg19} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img src={Bg19_1} alt="" width={'100%'}/><br /><br />
          6月19日下午，一场聚焦DeepSeek与办公效率提升的行业盛宴在北京锐中心成功举办。由熙诚教育投资主办的《AI办公提效》公开课，吸引了包括中国金币集团、北京图书大厦、菜百股份、老舍茶馆在内的多家西城企联会员企业代表参与。这场活动不仅是AI前沿技术的分享会，更是熙诚教育投资赋能会员企业数字化转型的生动实践，展现了其作为西城企联智库型会员单位的专业价值与资源整合能力。<br /><br />
          在数字经济快速发展的今天，人工智能技术正深刻改变着企业的运营模式。此次公开课摒弃了泛泛而谈的技术科普，转而采用"行业垂直+场景细分"的赋能模式，使得AI技术真正成为解决企业痛点的"手术刀"而非"钝器"。课堂上，老师针对不同行业特性量身定制了DeepSeek应用方案：我们为金融企业展示智能数据分析应用，为零售企业提供AI营销内容生成方案，为文化企业提供数字化内容生产工具，切实帮助会员企业提升运营效率。<br /><br />
          "这些工具彻底改变了我们的工作方式，”一位市场部负责人表示，“讲清楚自己的想法和思路，DeepSeek就可以快速产出方案，后续只需要再加工和润色就行，极大程度提升了我们的工作效率。"。<br /><br />
          一位科技公司产品经理表示："AI在需求文档撰写和原型设计方面的应用，将我们的产品开发周期缩短了至少20%。"<br /><br />
          许多参与者表示回去后就立即尝试在工作中应用公开课上所学的技能，并期待参加后续的进阶课程。<br /><br />
          "这不仅是一次培训，而是持续赋能的开端，"熙诚教育投资负责人表示，"我们希望成为西城企联会员企业数字化转型路上的长期伙伴，不仅提供培训支持，更将在企业咨询、技术资源对接等方面持续发力，充分发挥在西城企联中的智库作用，助力更多成员单位提质增效应对数字化挑战"。<br /><br />
          下一步，熙诚教育投资将持续深化"三位一体"的赋能模式：以行业需求为导向设计课程体系，以资源整合为支撑提供优质服务，以生态建设为目标促进协同创新。教学相长，与更多优质企业携手共同书写智慧商业的新篇章。
        </div>
      </div>
    </>
  )
}

const Detail20 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.07.02</div>
      <div className='detail-news-title'>“党建+业务”双融双促丨《AI办公提效》走进西城区党员教育基地</div>
      <img className='detail-news-banner' src={Bg20} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img src={Bg20_1} alt="" width={'660px'}/><br />
          图｜“西城区红墙先锋工程大碗茶党建聚力引领茶馆经营管理实践课堂”第五十六课《AI办公提效》<br /><br />

          值此中国共产党成立104周年之际，7月1日上午，由大栅栏街道商会与北京市大碗茶文化发展有限公司党支部联合主办的“西城区红墙先锋工程大碗茶党建聚力引领茶馆经营管理实践课堂”第五十六课《AI办公提效》在西城区党员教育基地——大碗茶党支部党建教研基地老舍茶馆举办。<br /><br />
          作为西城区的国有企业，熙诚教育投资充分发挥自身在企业咨询培训行业的优势，主动履行社会责任，为本次活动提供了课程支持。公司选派旗下AI技术专家王晓磊老师担任主讲，为与会企业代表深入讲解AI办公的前沿理念，并分享DeepSeek实用操作技巧。大栅栏街道干部；大栅栏街道商会会长、北京市大碗茶文化发展有限公司党支部书记、董事长、总经理，北京老舍茶馆有限公司董事长尹智君和部分大栅栏街道商会会员企业代表；大碗茶公司党员、入党积极分子、老舍茶馆经营管理团队共47人参加活动。<br /><br />
          本次《AI办公提效》课程聚焦企业办公场景中的实际痛点，通过“理论+实践”的教学模式，针对街道干部、商会企业员工的实际需求提供定制化AI赋能方案。例如，为文化企业演示数字化内容生产工具，为零售企业分享AI营销内容生成技巧，为传统服务企业展示智能数据分析应用，让参训人员快速掌握AI工具的应用并即可上手实践。另外，课程设置中充分体现“党建+业务”双融双促理念，将党建工作与企业发展深度融合，积极促成“政策引领、党建聚力、民生导向、创新驱动”的发展格局。<br /><br />
          <img src={Bg20_2} alt="" width={'100%'}/><br />
          图｜《AI办公提效》课程培训现场<br /><br />
          “这次培训让我们真切感受到，在党建引领下，AI正在为企业发展注入新动能。”大栅栏街道商会相关负责人表示：“从信息提取到创意生成，从精准分析到战略洞察，AI正成为驱动生产力跃升的新引擎。本次参训学员已经通过实操演练，快速掌握了DeepSeek辅助文档处理、数据分析、营销文案创作等实用技能，他们已成功迈出拥抱智能化转型的关键一步，为未来工作模式革新奠定了坚实基础。”<br /><br />
          《中共中央关于加强党的政治建设的意见》第五章第十二条明确提出："积极运用互联网、大数据等新兴技术，创新党组织活动内容方式，推进'智慧党建'"。这一重要论述为新时代党建工作指明了数字化发展方向。<br /><br />
          熙诚教育投资深入贯彻落实党中央决策部署，将"智慧党建"理念深度融入企业服务实践。此次《AI办公提效》培训活动的成功举办，正是公司以数字化手段创新党建工作的生动体现。活动不仅彰显了熙诚教育投资在践行国企责任、服务企业成长方面的坚定决心，更展现了公司在"智慧党建"和"党建数字化"领域的探索与实践。未来，公司将继续以党建为引领，以教育为纽带，以数字化为支撑，为商会企业提供更多优质资源与智力支持。<br /><br />
        </div>
      </div>
    </>
  )
}

const Detail21 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.08.01</div>
      <div className='detail-news-title'>京港同心向未来——熙诚教育投资助力2025“星动北京·未来之星”实习计划</div>
      <img className='detail-news-banner' src={Bg21} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          2025“星动北京·未来之星——香港大学生暑期内地实习计划”正式启动。熙诚教育投资积极响应丰台区“学子回家”行动号召，切实履行国企社会责任，为香港学子提供优质实习岗位与成长平台，助力其深度融入国家发展大局，拓宽职业视野，厚植家国情怀。<br /><br />
          <img src={Bg21_1} alt="" width={'100%'}/><br />
          图｜2025“星动北京·未来之星——香港大学生暑期内地实习计划”正式启动<br /><br />
          在本次实习计划中，公司秉持“引领中国奋进英才”使命，立足丰台区“青年友好生态城区”建设目标，紧密配合“丰才十条”与“国际人才港”政策，为香港学子量身定制涵盖讲师培养、项目管理和创新孵化等方向的实习岗位。通过“一对一”导师带教、实践任务赋能和职业规划指导，帮助学子快速适应内地职场环境，提升综合竞争力。<br /><br />
          熙诚教育投资代表表示：“作为国有企业，我们深知人才是发展的核心动力。支持香港青年在京实习，既是响应国家'港澳与内地融合'战略，也是为社会培养未来栋梁的重要实践。”<br /><br />
          除岗位实践外，公司积极支持“职场实践—创新探访—治理观察—文化体验”四位一体培养体系，依托企业资源优势，组织学子参访科技创新企业、参与行业论坛等活动，帮助其深入了解内地企业发展前沿动态，切身感受国家创新实力，进一步增强对祖国的认同感。<br /><br />
          未来，熙诚教育投资将持续深化政校企合作，完善实习就业联动机制，为更多港澳青年搭建“回家”发展平台，以实际行动践行国企使命，为京港人才交流与高质量发展贡献力量。<br /><br />
        </div>
      </div>
    </>
  )
}

const Detail22 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.09.05</div>
      <div className='detail-news-title'>《AI办公提效》课程走进“国资大讲堂”，助力区属机关单位办公效率提升</div>
      <img className='detail-news-banner' src={Bg22} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img src={Bg22_1} alt="" width={'660px'}/><br />
          图｜国资大讲堂之《AI办公提效》课程<br /><br />
          近日，由西城区国资委组织、熙诚教育投资老师主讲的“国资大讲堂”系列培训——《AI办公提效》专题课程成功举办。作为区属国有企业，熙诚教育投资充分发挥自身在企业培训与数字化服务领域的专业优势，积极整合优质资源，特邀AI技术专家王晓磊担任主讲，面向西城区国资委机关和下属事业单位的40余名干部开展人工智能实操培训，助力其提升办公效率，将AI技术转化为现实生产力。<br /><br />
          当前，人工智能正以前所未有的速度重塑各行各业的工作模式与管理模式。我们基于对区属机关单位实际需求的深入洞察，结合自身在数字化能力提升领域的丰富经验，聚焦DeepSeek等国产大模型工具，围绕智能文档生成、数据分析、创意辅助与流程优化等高频办公场景，设计了“理论+实操”一体化课程，帮助学员快速掌握AI应用技能，将前沿技术转化为实际生产力。<br /><br />
          <img src={Bg22_2} alt="" width={'50%'} height={'375px'} />
          <img src={Bg22_3} alt="" width={'50%'} height={'375px'} /><br />
          图｜老师带领学员进行DeepSeek实操演练<br /><br />
          培训现场，参训人员通过案例解析与动手实操，深入体验了AI工具在提升工作效率、优化决策质量等方面的显著效果。大家一致认为，熙诚教育投资提供的课程内容实用、教学方式生动，此次培训不仅是一堂技术应用课，更是一场思维革新课，为今后在工作中系统化、规模化应用数字技术打下坚实基础。<br /><br />
          作为西城区企业培训服务的重要力量，熙诚教育投资始终坚持以传递前沿思想，引领中国奋进英才为使命，公司依托深厚的行业积累和资源整合能力，不断打造与客户需求匹配的高质量培训产品与数字化解决方案。下一步，我们将继续发挥国有企业的平台优势和引领作用，持续拓展服务边界、升级赋能体系，为更多机关单位及国资企业输出新知识、新技术、新方法，为西城区数字经济高质量发展贡献智慧与力量。<br /><br />
        </div>
      </div>
    </>
  )
}

const Detail23 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.09.17</div>
      <div className='detail-news-title'>西纳英才、融创未来——西城首届“西融人才”国情研修班圆满收官</div>
      <img className='detail-news-banner' src={Bg23} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          为深入学习贯彻习近平总书记关于做好新时代人才工作的重要思想，加快推进高水平人才高地建设，搭建人才跨界交流学习平台，9月10日至12日，西城区委组织部（区人才工作局）举办2025年“西融人才”国情研修班。来自各领域的“西融人才”及人才工作者50余人参加集中研修。<br /><br />
          熙诚教育投资依托深厚的项目策划和运营能力，参与并协助2025年“西融人才”国情研修班圆满收官。<br /><br />
          <strong style={{fontSize: '20px'}}>铸就多元课程，淬炼前沿实战</strong><br />
          开班式上，西城区委常委、组织部部长于家明同志介绍了西城区的人文历史、经济概况等区情区貌，指出本次国情研修班是落实北京市建设高水平人才高地部署，推进教育、科技、人才“三位一体”协同融合发展的具体举措，结合“时代、舞台和共融”与人才交流想法，呼吁人才读懂时代，在人才的春天建功立业；鼓励人才积极把握机遇，在西城的舞台实现个人价值；期望各位学员深入共融，主动将个人发展对接区域战略需求，为建设高品质的幸福西城汇聚磅礴智慧和强大力量。<br /><br />
          区委组织部副部长、区人才工作局局长贾慧芳介绍了西城区人才“引育留用”的全链条政策体系和人才发展平台载体建设情况。<br /><br />
          <img src={Bg23_1} alt="" width={'660px'}/><br />
          研修班邀请了中国人事科学研究院原院长、中央人才工作领导小组办公室特聘专家吴江同志作专题辅导报告，深入分析了当前人才工作面临的新形势与新挑战，重点解读了建设世界重要人才中心和创新高地的重大意义、总体布局与关键举措。<br /><br />
          研修班设置“人才讲产业、人才谈事业、人才道国情”的人才交流模块，九位学员从体系融合、机制创新、资源整合等多个维度，系统探讨了跨领域合作的可能路径与实施策略。<br /><br />
          研修班邀请了字节跳动公司高管及技术人员，围绕“技术驱动、产品创新”的核心增长逻辑和AI大模型在智能办公领域的前沿实践等内容进行授课，帮助学员们把握智能化转型趋势。<br /><br />
          <strong style={{fontSize: '20px'}}>启迪沉浸思辨，聚力碰撞新声</strong><br />
          除了扎实的理论输入，本次研修班同样注重互动与实践。<br /><br />
          专题研讨：本期研修班设置专题研讨环节，旨在通过思想碰撞与智慧交融，凝聚共识、激发创新。通过多轮深度研讨，学员共同提出了一系列既具前瞻视野又具备可行路径的人才发展建议，有效促进了跨行业之间的交流与合作，为区域人才建设提供了务实解决方案。此次研讨不仅进一步强化了共识，更构建起高层次人才协同创新网络与生态，切实将研讨成果转化为推动西城区高质量发展的持续动力。<br />
          <img src={Bg23_2} alt="" width={'660px'}/><br />
          企业参访：学员们集体前往北京菜市口百货股份有限公司开展现场教学。菜百股份党委书记、董事长谢华萍讲述了企业如何通过“数智赋能”与“人才筑基”双轮驱动战略，有效推进技术创新与组织升级，实现高质量增长与可持续发展。<br /><br />
          金融街资本党委书记、董事长程瑞琦围绕《企业发展的价值迁移》，讲述从提供基础产品功能，转向满足用户深层体验与情感认同，企业需不断将价值从“实物”向“服务”“品牌”乃至“数字化生态”迁移，通过创新商业模式，抢占价值链高端，实现持续增长。<br /><br />
          学员们通过深入企业的实地观摩与高层管理者的面对面座谈交流，全方位、多角度地了解了数智驱动的前沿技术应用与实战管理经验，智能系统的流畅运作、数据驱动的精准决策，都给学员带来了极大震撼。这些成功的实践案例成为学员们理解智能驱动最鲜活的样本，极大地强化了学员对推行数字化战略的紧迫感。<br />
          <img src={Bg23} alt="" width={'100%'}/><br /><br />
          <strong style={{fontSize: '20px'}}>深化使命认同，跃动创新引擎</strong><br />
          本次研修班紧扣区域发展需求，以“深化认知、促进协作、推动发展”为主线，成功为“西融人才”构建起跨领域、多层次的交流平台，凝聚了“融入融合融汇、聚力赋能西城”的广泛共识。<br /><br />
          三天的学习时间，各行各业的优秀人才汇聚在一起，在课堂上潜心研学、在研讨中碰撞思想、在交流中增进友谊。学员们普遍认为，本次研修班不仅拓展了视野、提升了素养，更促进了人才之间的资源对接与项目合作，为共同服务西城高质量发展注入了新动力。<br /><br />
          未来，熙诚教育投资将持续以专业内容和精细化运营为双翼，为行业的高质量与可持续发展贡献专业力量。<br /><br />
         </div>
      </div>
    </>
  )
}

const Detail24 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.10.20</div>
      <div className='detail-news-title'>深化运营谋发展 锤炼团队赢未来｜熙诚教育投资助力广东机场物流锻造高质量管理梯队</div>
      <img className='detail-news-banner' src={Bg24} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          为深入贯彻落实集团公司“1236”战略部署，加速构建企业人才高地，广东省机场集团物流有限公司于9月-10月期间系统开展了2025年管理人员运营管理系列培训。本次系列培训由熙诚教育投资提供专业支持，聚焦运营效能提升，分阶段实施“财务管理思维”“经营管理思维”及“精益生产思维”三大核心模块，为企业高质量发展注入持续人才动能。<br />
          <img src={Bg24_1} alt="" width={'660px'}/><br />
          2025年管理人员运营管理培训<br /><br />
          <strong style={{fontSize: '20px'}}>精准把脉：以战略为导向设计培训体系</strong><br />
          随着物流行业竞争日益激烈，企业对管理人员的综合素质提出了更高要求。广东机场物流敏锐把握这一趋势，将管理团队能力建设提升到战略高度，启动年度管理人员系列培训项目。<br /><br />
          熙诚教育投资深度对接企业需求，围绕“成本精细化管理”“业财融合与预算管理”“经营管理思维”三大核心内容，精心设计了涵盖财务管理思维、商业敏锐度沙盘、精益生产思维的综合性培训方案。<br /><br />
          “培训不再是零散的知识灌输，而是与企业战略紧密衔接的系统工程。”熙诚教育投资项目负责人强调，“我们致力于通过层层递进的课程设计，帮助管理人员建立系统思维，实现从认知到行为的根本转变。”<br /><br />
          <strong style={{fontSize: '20px'}}>课程实战：在模拟推演中锤炼真本领</strong><br />
          财务管理课程上，老师从研发、采购等关键环节入手，深入剖析成本控制策略与预算制定流程，结合GSK等真实案例，帮助学员建立业财融合思维，提升资源配置与战略执行能力。<br /><br />
          经营管理思维沙盘模拟课程通过模拟企业运营场景，让学员在模拟决策中深入理解运营逻辑、风险管控与资源优化配置，有效提升了管理人员的战略思维和实战能力。<br /><br />
          “沙盘推演让我真正理解了企业经营的本质，”一位参与培训的管理人员感慨，“原来只关注自己部门的指标，现在学会了从企业整体盈利的角度思考问题。”<br />
          <img src={Bg24_2} alt="" width={'100%'} /><br />
          注丨Photo from 熙诚教育投资<br />
          图｜ 课程现场：从“被动接受”到“主动探索”<br /><br />
          精益生产思维课程中，老师带领学员绘制物流作业全流程价值流图，识别七大浪费，应用TOC约束理论突破瓶颈。学员们现场输出《效率提升速赢方案》，为后续工作改进提供了具体抓手。<br /><br />
          <strong style={{fontSize: '20px'}}>培训成果：实现了三个重要转变</strong><br />
          此次培训突破了传统培训的局限，实现了三个重要转变：<br />
          从“知识传递”到“思维构建”——学员不仅掌握了运营管理知识，更建立了系统思考框架；<br />
          从“被动接受”到“主动探索”——沙盘模拟激发学员主动应用策略、解决实际问题的能力；<br />
          从“个体学习”到“团队共创”——跨部门协作的课程设计增强了团队凝聚力与协同意识。<br /><br />
          <strong style={{fontSize: '20px'}}>培训实施与服务亮点</strong><br /><br />
          <strong>系统化课程结构，层层递进</strong><br />
          本次培训从“财务基础”到“经营模拟”再到“精益实战”，形成了从认知到行为、从理论到实践的完整闭环，确保学员在思维层面与操作层面同步提升。<br /><br />
          <strong>实战导向，学以致用</strong><br />
          沙盘模拟、案例研讨等多种教学方式相结合，强化学员在真实场景中的决策能力与问题解决能力。学员在培训后即能认领业务课题，推动管理改进落地。<br /><br />
          <strong>讲师团队专业深厚，经验丰富</strong><br />
          三位讲师均具备丰富的企业实战与教学经验，服务客户覆盖物流、医药、制造、金融等多行业，确保课程内容兼具前瞻性与落地性。<br /><br />
          参训学员普遍反映，本次培训不仅系统梳理了运营管理的知识体系，更通过沙盘推演与案例实战，激发了团队创新活力与协同意识。学员表示将把所学所悟应用于实际工作，持续优化业务流程，提升管理效能。<br /><br />
          作为深耕企业培训领域的专业机构，我们始终以“为世界打造中国式企业管理典范”为目标，已为众多知名企业提供人才培养解决方案。此次与广东机场物流的成功合作，再次印证了其“以客户为中心、以价值创造为导向”的服务理念。<br /><br />
          接下来，我们将继续与广东机场物流携手，持续推进高素质管理人才队伍建设，以精准化、系统化的培训机制，不断夯实企业管理基础，为集团战略落地和公司转型升级提供坚实的人才保障和智力支持。<br /><br />
        </div>
      </div>
    </>
  )
}

const Detail25 = () => {
  return (
    <>
      <div className='detail-news-date'>2025.12.31</div>
      <div className='detail-news-title'>2025.12.31-2025丨聚势内升</div>
      <img className='detail-news-banner' src={Bg25} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <strong style={{fontSize: '20px'}}>2025丨聚势内升</strong><br /><br />
          <strong>2025年</strong><br />
          我们以“聚势内升”为信念，<br />
          与客户并肩，与团队同心，<br />
          向内凝聚共识，向上突破边界。<br /><br />
          <strong>优·产品</strong><br />
          这一年，<br />
          我们聚焦核心业务凝炼产品，<br />
          发布【2026年度学习赋能计划】。<br />
          多元内容+多样化全新场景，<br />
          为客户量身打造“成长操作系统”，<br />
          让企业的每一次学习都长出利润。<br />
          <div style={{backgroundColor: '#eff4f5'}}>
            <img src={Bg25_1} alt="" width={'50%'} />
            <img src={Bg25_2} alt="" width={'50%'} />
          </div><br /><br />

          <strong>优·产品</strong><br />
          这一年，<br />
          我们持续推进中国式企业管理范式的深化实践，<br />
          不仅传承智慧，更在真实困境中与客户共同锻造解决方案。<br />
          我们精选并整合多个行业标杆案例，<br />
          构建可复制、可推广的“方法论库”，<br />
          让管理智慧不止于课堂，更融入经营的生命线。<br />
          <img src={Bg25_3} alt="" width={'600px'} /><br /><br />
          <strong>塑·服务</strong><br />
          这一年，<br />
          我们重塑服务链路。<br />
          从项目运营到讲师服务，<br />
          从响应陪伴到执行共创。<br />
          我们在每一个需求节点深度嵌入，<br />
          让服务不再只是支持，而是共同进化的旅程。<br />
          <img src={Bg25_4} alt="" width={'600px'} /><br /><br />
          <strong>升·价值</strong><br />
          这一年，<br />
          我们与合作伙伴深入共建，<br />
          在其战略转型、组织调整、市场攻坚的关键时期，<br />
          我们深度陪跑，实现价值突破，<br />
          成为真正的“陪练者”与“共升者”。<br />
          <img src={Bg25_5} alt="" width={'600px'} /><br /><br />
          <strong>锻·内力</strong><br />
          这一年，<br />
          我们向内锻造组织韧性，<br />
          推动每一位成员从“业务尖兵”向“自我管理者”进化。<br />
          通过内部培训、经验分享等机制，<br />
          突破认知，夯实执行，赋能全员多维成长，<br />
          以团队的整体进化，应对市场风浪。<br />
          <img src={Bg25_6} alt="" width={'600px'} /><br /><br />
          真正的能量，来自内部的紧密凝聚<br />
          真正的突破，始于蓄势后的向上生长<br />
          从共行，到共力；从内升，到共成<br /><br />
          2026年<br />
          故事仍在继续未<br />
          来正在聚势中绽放生长<br />
          “共赴新程，依旧并肩。”<br />
        </div>
      </div>
    </>
  )
}

const Detail26 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.02.02</div>
      <div className='detail-news-title'>洞察“十五五”新格局，锻造新质生产力时代增长韧性——“共生·共谋·共成长”2026企业韧性增长实战论坛在京成功举办</div>
      <img className='detail-news-banner' src={Bg26} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          2026年1月30日，由熙诚教育投资主办的“共生·共谋·共成长——2026企业韧性增长实战论坛”在北京丽泽SOHO成功举行。本次论坛聚焦“十五五”新格局下的企业战略机遇与新质生产力驱动下的组织进化路径，特邀五位国内顶尖实战专家，围绕政策解读、营销升维、绩效改进、数字化人才与组织敏捷等核心议题展开深度分享，吸引了诸多企业管理者、战略决策者与行业伙伴齐聚一堂，共探韧性增长之道。<br /><br />
          <img src={Bg26_1} alt="" width={'100%'}/><br />
          图｜共生·共谋·共成长——2026企业韧性增长实战论坛<br /><br />
          论坛在熙诚教育投资总经理张笑妮的开幕致辞中拉开帷幕。她表示：2026年是“十五五”新格局展开之年，也是企业深刻转型、锻造韧性的关键阶段。我们希望借助这一<span style={{color: 'red'}}>聚焦真问题、搭建好内容、营造能深度交流的场域，</span>助力大家在碰撞中找到属于自己企业的“开局之钥”。<br /><br />
          <img src={Bg26_2} alt="" width={'100%'}/><br />
          图｜熙诚教育投资总经理张笑妮致开幕词<br /><br />
          汤敏：“十五五”规划下的产业变革与企业战略机遇<br />
          著名经济学家汤敏首先带来《国家新蓝图：“十五五”规划下的产业变革与企业战略机遇》主题分享，他从宏观经济政策与产业结构演变入手，系统解读了“十五五”规划的核心导向与潜在增长点，为企业锚定发展方向提供了坚实的政策锚点与趋势判断。<br /><br />
          <img src={Bg26_3} alt="" width={'100%'}/><br />
          图｜著名经济学家汤敏系统解读“十五五”规划的核心导向与潜在增长点<br /><br />
          汤敏指出，“十五五”是实现2035年中等发达国家目标的关键阶段，2026年GDP增速目标预计为5%，宏观政策将延续“三箭齐发”，财政支持力度持续加码。他强调，新质生产力是“十五五”核心引擎，人工智能更是关键驱动力。国家将构建“新兴产业+未来产业”双轮驱动格局，涵盖新能源、量子科技、生物制造等前沿领域，并通过“人工智能+”行动深度融合六大产业。他以水星家纺为例，展示企业如何通过“全员AI大赛”实现技术从IT部门走向业务一线，完成效率提升与流程重构。<br /><br />
          针对产业机遇，汤敏聚焦金融、新能源、大健康、新消费四大赛道作重点分析，他建议企业主动拥抱变革，在政策与科技双轮驱动下锻造增长韧性。<span style={{color: 'red'}}>“每一代人的代际淘汰，更多来自对新工具的率先应用。</span>”汤敏呼吁企业把握“十五五”这一转型破局的关键五年，以务实行动迎接产业重构的历史机遇。<br /><br />
          夏凯：存量时代，企业如何摆脱同质化竞争、实现可持续增长？<br />
          新质生产力驱动企业营销战略升维的大背景下，企业如何摆脱同质化竞争、实现可持续增长？国内企业增长战略营销体系咨询专家夏凯在演讲中，通过“将一张白纸卖出高价的某造纸行业上市公司”经典案例与一套系统方法论，揭示了存量时代下企业逆势增长的底层心法。<br /><br />
          <img src={Bg26_4} alt="" width={'100%'}/><br />
          图｜国内企业增长战略营销体系咨询专家夏凯主题分享：存量时代下企业逆势增长的底层心法<br /><br />
          在产能过剩、同质化严重的传统造纸行业，一家拥有50万吨固定产能的上市公司却实现了利润的历史性突破。其背后的关键，并非技术创新或市场扩张，而是一套重新定义价值的思维革命——按“价值生命周期”对产品进行分类。<br /><br />
          传统分类方式聚焦物理属性，如文化纸、工业纸，难以摆脱价格竞争。而夏凯提出了新逻辑，将纸张依据使用场景与保存时长划分为：“一日生命”（如报纸）、“半年生命”（如教材）与“永久生命”（如经典典籍）。这一分类直接指向了完全不同的价值区间与客户需求。<br /><br />
          基于此，该企业展开了一场从产品到客户的系统变革：针对“永久生命”场景，研发符合国家级文献保存要求的特种纸；推出“风、雅、颂、赋”品牌系列，实现大众产品走渠道、高端产品直供头部客户的精准分层；更重要的是，企业毅然主动淘汰142家低价值客户，同时新开发129家优质供应商，将产能与资源全力聚焦于高毛利细分市场。<br /><br />
          结果印证了选择的威力：在总产能未增的情况下，企业办公及高档纸销售额同比增长421%，创下利润新高。<br /><br />
          夏凯强调这一案例的核心启示：<span style={{color: 'red'}}>“在存量时代，企业最危险的动作就是试图满足所有人的需求。真正的增长来自于深度价值洞察后的战略性选择——不是你能做什么，而是你应该为谁做、不替谁做。放弃低价值市场，聚焦高价值场景，这是传统行业突破同质化竞争的唯一路径。”</span><br /><br />
          他进一步指出：“很多企业苦苦寻找的‘新市场’，往往是别人已经卷成红海的存量市场。真正的蓝海，就藏在客户未被充分满足的价值场景中，等待你用新的分类逻辑去发现和定义。”<br /><br />
          易虹：科学增长 精准破局——绩效改进实现组织高质量增长<br />
          下午场聚焦组织内在能力的系统性提升。国内著名绩效改进专家易虹以《科学增长 精准破局——绩效改进实现组织高质量增长》为题，深刻揭示了绩效改进并非传统的考核管理，而是一套以结果为导向、以科学方法为路径的管理哲学，旨在驱动组织实现“增效降本”的高质量增长。<br /><br />
          <img src={Bg26_5} alt="" width={'100%'}/><br />
          图｜国内著名绩效改进专家易主题分享：如何让组织在增效降本中实现高质量增长<br /><br />
          易虹开门见山地指出，在竞争激烈的当下，企业增长的关键在于“选对、找准、做精”。她强调，真正的分析思维应是“指哪打哪”——基于客观的市场、竞争、客户与自身分析，锁定优势与机会点，而非“打哪指哪”式的自我证明。她通过多个行业案例，展示了绩效改进如何在不增加额外资源的情况下，实现业绩增长。易虹特别指出，技术是“主力”而非“主角”，其成功赋能的前提是洞悉业务本质与逻辑。<br /><br />
          易虹系统阐述了驱动绩效改进的四对核心思维：分析思维与执行思维、本质思维与现象思维、结果思维与问题思维、赋能思维与管控思维。她以“缩短报销时间”“降低课程退费率”等具体课题为例，生动诠释了如何超越表面工作流程，透视业务本源，重构问题并与组织目标对齐。她强调了“技控”先于“人控”的管理干预逻辑，指出通过优化环境、流程与工具（技控）来提升员工完成任务的水平，是比单纯要求态度（人控）更为有效的赋能方式。<br /><br />
          “没有结构性调整，质变几乎不可能。”易虹总结道，<span style={{color: 'red'}}>绩效改进的精髓在于通过精准的结构性分析与干预，找到业务增长的关键杠杆点，实现“事成人长”——既解决业务难题，更历练团队思维与能力，从而为组织锻造持续进化的内生动力。</span><br /><br />
          陈澄波：数字化人才管理——从数据孤岛到效能星图<br />
          国内著名组织学习与人才管理专家陈澄波分享了题为《数字化人才管理实践——数据孤岛到效能星图》相关内容。他从入选国务院国资委优秀项目的实战经验出发，深入探讨了在数字化浪潮下，企业如何打破人才数据壁垒，构建公平、高效且能持续激活组织活力的人才管理新范式。<br /><br />
          <img src={Bg26_6} alt="" width={'100%'}/><br />
          图｜国内著名组织学习与人才管理专家陈澄波分享数字化人才管理实践<br /><br />
          陈澄波直指当前企业人才管理的三大痛点：数据不清、标准模糊、过程黑箱。他认为，实现数字化人才管理的关键在于遵循“公开、公平、公正”的三公原则，构建一套能够让员工信任的、可量化、可追溯的评价与发展体系。他创造性地提出并详细解构了“人才积分制”这一核心模型。该模型借鉴了城市人才引进积分制的逻辑，通过建立全面、客观、可量化的积分指标体系，将员工的能力、经历、绩效等要素转化为动态积分，并依据积分自动实现后备人才入库。通过在某大型电力集团的落地实践，该体系实现了对26个专业序列、全级次人才的穿透式、可视化精细管理，使人才选拔从“相马”转向更精准的“赛马”，为国企干部年轻化、人才结构优化提供了科学的决策支持。<br /><br />
          陈澄波描绘的“效能星图”，不仅是一套数字化工具，更是一种人才治理思维的升维。它让人才数据真正流动起来，为企业战略落地提供了清晰、动态的人才画像与储备地图。<br /><br />
          李文波：提升组织敏捷力——让使命愿景贯穿战略运营<br />
          国内领先的敏捷组织转型专家李文波以《提升组织敏捷力：使命愿景贯穿战略运营一致性》为主题，为全天论坛进行了深刻收尾。他犀利指出，在业务组合日益复杂、增长策略多维并进的时代，组织面临的不仅是协同效率问题，更是如何在动态与稳定间取得平衡，以及如何让组织的“灵魂”——使命愿景——真正成为引领一切行动的北斗星。<br /><br />
          <img src={Bg26_7} alt="" width={'100%'}/><br />
          图｜国内领先的敏捷组织转型专家李文波：提升组织敏捷力<br /><br />
          他指出，敏捷组织并非一种固定的架构形态，而是一种兼具“强大稳定基础”与“强大动态调整能力”的组织状态。它需要具备适应变化、自我纠偏和自行调整三大核心能力。然而，比这些能力更底层、更关键的是组织的使命愿景能否深入人心并贯穿始终。他批判了将使命愿景沦为墙标口号的现象，强调真正的使命愿景是能够回答“企业为何存在、以何种独特方式存在”的根本命题，是激发组织超越短期利益、应对长期挑战的精神内核。<br /><br />
          通过分享其为一家全球化创新药企重塑组织灵魂的咨询案例，李文波展示了如何通过深度访谈、数据调研与AI工具辅助，对企业文化体系进行诊断与刷新，并将抽象的使命愿景转化为可衡量、可管理的战略里程碑与组织原则，最终构建从“使命愿景”到“战略目标”再到“组织行动与人才机制”的一致性闭环。他强调，在AI时代，文化梳理与战略澄清的方法正在革新，但核心依然是领导者言行合一、组织上下共识并践行。<br /><br />
          李文波总结道，<span style={{color: 'red'}}>锻造组织韧性，不仅需要外在的战略、营销、绩效与人才工具，更需要向内凝聚共识、校准方向。只有当使命愿景真正成为照亮组织前行的北斗星，企业才能在瞬息万变的环境中保持定力、敏捷响应，驶向可持续增长的彼岸。</span> <br /><br />
          共筑韧性，笃行致远<br /><br />
          从“十五五”的宏观洞察，到新质生产力下的营销升维，再到向内求索的绩效改进、数字化人才管理与组织灵魂锻造，五位实战专家的分享层层递进，共同勾勒出新质生产力时代企业韧性增长的完整路径。这不仅是思维的革新，更是行动的路标。<br /><br />
          面对不确定性的时代浪潮，韧性，从来不是静态的防御，而是动态进化的能力；增长，也绝非偶然的运气，而是系统设计的必然。熙诚教育投资深信，唯有在共生中汲取力量，在共谋中凝聚智慧，在共成长中兑现价值，企业方能穿越周期，基业长青。<br /><br />
          论坛虽已落幕，探索永不止步。熙诚教育投资愿携手所有企业家、管理者，将今日的启发化为明日变革的勇气与行动的锐力，在高质量发展的星辰大海上，乘风破浪，共赴壮阔未来。

        </div>
      </div>
    </>
  )
}

const Detail27 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.02.11</div>
      <div className='detail-news-title'>深耕专业·拓界前行：熙诚教育投资成功举办“4C探界者计划”2025年度优秀案例分享与共创会</div>
      <img className='detail-news-banner' src={Bg27} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          <img src={Bg27_1} alt="" width={'100%'}/><br />
          2026年2月11日，为系统沉淀组织智慧、激发创新动能、赋能高质量发展，熙诚教育投资于丽泽SOHO隆重举办<span style={{color: 'red'}}>“4C探界者计划——2025年度优秀案例分享与共创会”。</span> 本次活动以“每一步实战都有光，每一次分享皆可传承”为精神指引，面向公司全员，围绕2025年度标杆性培训与咨询项目展开深度复盘与集体共创。通过15个真实案例的全景呈现与四重价值维度的体系化萃取，活动不仅展示了熙诚教育投资团队在复杂商业环境下的专业韧性与创新突破，更标志着公司在知识资产管理、组织能力升级与学习型生态构建方面迈出了系统性、战略性的关键一步。<br /><br />
          <strong style={{fontSize: '20px'}}>4C理念深耕：从价值主张到组织实践的系统落地</strong><br /><br />
          “4C探界者计划”根植于熙诚教育投资一贯倡导的“成长型思维”与“价值共创”文化。本次活动以“4C”为核心框架，将理念转化为可感知、可参与的实践场景：<br />
          <strong>连接业务 Contextualize</strong><br />
          深入业务场景，将学习目标与组织的核心挑战及员工的真实工作相连接。我们不仅是知识的传授者，更是业务问题的解码者和价值共创的伙伴。确保每一个学习项目都“为战而学”，精准回应业务痛点，明确其对于提升组织效能的具体贡献。<br /><br />
          <strong>创造体验 Create</strong><br />
          超越传统的课程堆砌，运用教学设计原理与前沿科技，精心打造沉浸式、互动式、启发式的学习旅程。激发学员的内在学习动力，让学习过程变得有趣、有效、有吸引力。<br /><br />
          <strong>催化成果 Catalyze</strong><br />
          关注学习的终极目标——行为改变与绩效提升。通过持续的跟进、辅导与实践支持，催化学习成果在真实工作场景中的转化与应用，让投入可见，让成长发生。让学习不止于课堂，而是能切实转化为驱动个人与组织前进的动能。<br /><br />
          <strong>固化资产 Capitalize</strong><br />
          不仅关注项目交付的完成，更注重组织知识资产的构建与赋能。通过多维度的评估体系、深度的效果复盘与可复用的方法论提炼，推动学习项目与组织发展持续共进，让每一次成功都能照亮未来的征途，使学习能力成为组织持续发展的核心引擎。<br /><br />
          <strong style={{fontSize: '20px'}}>实战智慧激荡：15个案例全景呈现组织能力图谱</strong><br /><br />
          全天活动紧密围绕“从案例到资产”的核心主线，汇集了来自金融、消费、高端制造、航空运输、文化传媒、公共事业等多元赛道的15个标杆案例。每一则案例都生动诠释了“挑战-破局-成长-沉淀”的完整价值循环，共同绘就了一幅熙诚教育投资在各领域赋能组织成长的能力全景图。<br /><br />
          此外，活动摒弃了传统的单向汇报模式，创新设置“庖丁解牛”式案例拆解与“现场问诊”式互动答疑。每位负责人用15分钟呈现项目精髓，随后接受来自不同部门同事的针对性提问。现场发放的“案例共创卡”成为知识流动的实体纽带，与会者即时记录灵感、提出优化建议、勾画迁移应用场景。这种高强度、高密度的思维碰撞，不仅解答了具体业务难题，更在潜移默化中打通了部门壁垒，塑造了跨领域协同解决问题的共同语言与思维框架。<br /><br />
          《“金色工程”人才体系培养项目·金色未来》金色工程项目系统构建了覆盖各级人才序列的培养体系，以系统性育才，打造系统化、专业化、创新性的“金色学堂”。“金色未来”项目作为“金色工程”的重要组成部分，着重培养学员的管理能力、专业技能和创新思维，加速其从业务能手向管理骨干的转型，夯实公司基层管理梯队。<br /><br />
          《复合经营型后备干部的体系化培养模式探索》<br /><br />
          该项目将企业战略诉求与个人成长路径深度绑定，实现能力的阶梯式攀升。不仅成功锻造了一支能征善战的未来干部队伍，更关键的是，它为客户构建了持续自我进化的人才造血机制，将人才优势真正转化为了组织的核心竞争优势。<br /><br />
          《金YUE荟·集团企业学习互动融合平台建设》<br />围绕“解决人才培养‘学不会、学不到、学不好、用不了’”目标，以学习型组织理念为指引，构建“人才-知识-场域”联动的学习平台体系。<br /><br />
          《战略对齐，组织破局·赋能30亿冠军企业的高管团队实战升级》<br />通过定制化内容、沉浸式体验与持续社群互动，不仅推动团队战略共识与信任建立，更将项目打造成企业年度“十大事迹”，实现从培训交付到组织发展的价值升级。<br /><br />
          《客户洞察创造价值，赋能头部外企业务增长》<br />项目立足头部外企，以深度客户/市场洞察为切入点，通过“成就客户的客户”实现深度价值创造，构建核心竞争壁垒，从而精准赋能业务增长。<br /><br />
          《“共赴未来，迈向幸福时代”2025年优秀讲师游学系列》<br />为客户提供全流程服务，统筹行程策划、研学参访、交通住宿、餐饮会务及拓展活动等所有环节，致力于一站式卓越交付体验，全力达成客户人才赋能与文化凝聚的核心目标。<br /><br />
          《匠心筑梦，技控创效·打造工匠人才，共筑降本增效新篇章》<br />技控大赛以“匠心筑梦、技控创效”为主题，“内部导师+外部顾问”，“线上微课+线下辅导”全面赋能，给客户带来上千万经济效益。<br /><br />
          《祥翼国际成长营·第一期国际化人才培养》<br />基于对该航空公司“海外战场站稳脚、打胜仗”战略意图的深度理解，以“派得出、能战斗”为目标，构建出一套覆盖“测-训-练-评”全流程的国际化人才成长闭环，助力客户打造有质有序的继任梯队。<br /><br />
          《线上练兵·AI赋能打造金融数字人才规模化培养》<br />智慧赋能，人才筑基。“兴知·数智化训练营”以系统化培训，规模化赋能，成功构建全行数字人才基座，为金融数字化转型建立了可复制的新范式。<br /><br />
          《“西融人才”国情研修班》<br />“西融人才”国情研修班，以政策解读、跨界交流、实地参访为核心，破解人才协作壁垒，收获高满意度与实质合作成果。<br /><br />
          《“百团兴百村·京心‘乡’伴”助力乡村振兴》<br />项目成功探索了“设计驱动乡村振兴”的可复制模式,通过品牌化、系统化设计服务助力乡村文化塑造与产业升级，赋能乡村发展，彰显国企服务国家战略的担当。<br /><br />
          《目标与绩效管理体系搭建》<br />该项目帮助客户解决市场化转型中的核心管理挑战，包括确立集团管控方式，搭建全面预算管理体系、构建目标与绩效管控等，助力其实现高质量发展。<br /><br />
          《知名金融证券企业1500人运动会》<br />通过持续、系统的赛事组织与品牌化活动运营，不仅展现了投行人团结拼搏、积极进取的精神风貌，更以体育为纽带，强化了团队凝聚力、提升了企业文化的感染力，助力客户在内部激发活力、对外树立健康向上的专业形象，实现了从活动执行到精神赋能的深度价值创造。<br /><br />
          《内容无界，未来共生·第十八届作家年会》<br />从会议流程设计、嘉宾规格接待、会场创意搭建到统筹全流程落地，在西双版纳为客户呈现了一场高规格、多维度的文学盛会，激发了作家的创作灵感，提高了作家与平台之间的粘性，促进作家之间的分享交流，助力客户推动中国内容“数字出海”，与全域内容伙伴合作共赢。<br /><br />
          《剧场破冰·AI赋能组织协同与数字化转型实践》<br />为客户提供创新培训方案，通过“企业剧场”促进干部协作，结合AI工具提升数字化能力，为企业构建了“三位一体”的培养新模式。<br /><br />
          <strong style={{fontSize: '20px'}}>荣誉时刻与未来启航：致敬卓越，共绘蓝图</strong><br /><br />
          在总结表彰环节中，公司为在案例价值沉淀与知识共建中表现突出的团队与个人颁发系列奖项。多个项目团队凭借其系统性、创新性及可复用性，分别荣获“2025年度「4C探界者计划」最佳案例奖”、“经典案例收录奖”及“案例贡献奖”，这些项目成果将成为公司知识资产体系的重要组成部分。<br /><br />
          同时，为鼓励深度思考与协同共创，公司向在互动中提出建设性见解的同事颁发了“最佳提问奖”，体现了组织对“在提问中学习，在对话中共进”的开放文化的倡导。<br /><br />
          这些奖项不仅是对过往实践成果的认可，更是对“专业精进、开放共创、知识传承”组织文化的持续塑造，为“4C探界者计划”的深入推进注入了持续动力与集体共识。<br /><br />
          熙诚教育投资总经理张笑妮对本次活动做出总结：本次分享会不仅是内部经验的交流平台，更是公司推动组织能力系统化升级的关键里程碑。它标志着公司从依赖个体经验的“点状突破”，正式迈向依托体系化知识资产驱动发展的“系统赋能”新阶段。未来，此类型的活动将作为常态化机制持续深化。公司号召全体员工以本次活动为起点，持续沉淀智慧、开放共创，共同构建组织持续进化的“智慧生态”，为赋能客户、引领行业积淀更坚实的底层能力。<br /><br />
          <strong style={{fontSize: '20px'}}>战略意义深远：打造可持续的组织成长新范式</strong><br /><br />
          本次“4C探界者计划”分享会的成功举办，具有超越活动本身的多重战略意义：<br /><br />
          它是一次组织智力的系统性盘点与升级：将散落各处的隐性知识显性化、结构化，初步构建起公司动态生长的“战略知识图谱”。<br /><br />
          它是一台强劲的协同赋能引擎：通过跨部门、跨项目的深度对话，促进了前中后台的理解互信，为未来应对综合性、复杂性挑战积蓄了“军团作战”的合力。<br /><br />
          它是一座鲜活的文化熔炉：让“客户至上、专业为本、分享共进”的核心价值观在真实的案例故事与互动中得到淬炼与传承，极大增强了组织的凝聚力与内驱力。<br /><br />
          它是一条赋能人才的高速通道：为新老员工提供了站在“巨人肩膀”上快速学习的机会，加速了个人能力与组织需求的对齐与提升。<br /><br />
          接下来，熙诚教育投资将围绕本次活动的产出，快速推进在线案例库平台建设以及“经验贡献”激励机制的落地。持续推动知识流动与价值创造，在赋能中国企业组织成长的道路上，步履坚实，光耀前行。
        </div>
      </div>
    </>
  )
}

const Detail28 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.05.08</div>
      <div className='detail-news-title'>“红色研学——重走五四路”骑行活动顺利举办</div>
      <img className='detail-news-banner' src={Bg28} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          为重温革命先辈奋斗历程、锤炼优青干部优良作风，5月7日，西城区国资委举办“红色研学——重走五四路”骑行活动。来自各区属国企的数十位优青骨干参与其中，以骑行方式走访五四运动重要历史地标。<br /><br />
          <img src={Bg28_1} alt="" width={'100%'}/><br /><br />
          本次活动是国企优青干部人才培训班开启后的首次实践教学。整个培训班共设置“红色研学、标杆企业参访、集中授课、案例分享会”四大阶段，其中“红色研学”以“爱国、进步、民主、科学”的五四精神为引领，帮助优青干部人才从红色历史中增强理想信念、塑造优良作风。<br /><br />
          骑行过程中，带班老师每到一处地标便现场讲述五四运动的背景、经过与历史意义。从新文化运动的思想启蒙，到五四运动爆发时青年学子走上街头的呐喊，再到马克思主义在中国的早期传播，学员们在实景中回顾了百年前那一代青年的热血抉择。<br /><br />
          <img src={Bg28_2} alt="" width={'100%'}/><br /><br />
          通过半天的沉浸式研学，大家对五四运动的历史脉络和精神内核形成了更加真切的认知。部分学员结合自身岗位实际工作，就如何将红色精神转化为攻坚克难、团队协作、廉洁自律的具体行动展开了深入交流，进一步明确了新时代国企青年的责任担当。<br /><br />
          <img src={Bg28_3} alt="" width={'100%'}/><br /><br />
          随着最后一支小队抵达终点，本次重走五四路骑行活动在积极、热烈的氛围中圆满落下帷幕，实现了红色教育与团队建设的有效融合，为国企高质量发展注入青春动能。
        </div>
      </div>
    </>
  )
}

const Detail29 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.05.15</div>
      <div className='detail-news-title'>喜迁新址 聚力启新</div>
      <img className='detail-news-banner' src={Bg29} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          为深度扎根西城产业高地、充分发挥国企平台资源整合优势，更好赋能区域产业升级、整合全国优质产业资源、提升公司全域运营服务效能，北京熙诚教育投资有限公司（以下简称“熙诚教育投资”）正式乔迁至——新动力金融科技中心。本次迁址不仅是办公场地的全新升级，更是公司立足西城、辐射全国，依托顶级产业平台深耕主业、服务全国市场的重要战略布局，为企业高质量、规模化发展筑牢坚实根基。<br /><br />
          <img src={Bg29_1} alt="" width={'100%'}/><br /><br />
          2026年5月13日，熙诚教育投资组织全体员工开展新动力金融科技中心参访交流活动，全员沉浸式体验全新办公环境与前沿产业氛围，以崭新平台为发展起点，凝心聚力擘画企业高质量发展崭新篇章。<br /><br />
          <img src={Bg29_2} alt="" width={'100%'}/><br /><br />
          参访过程中，新动力金融科技中心相关负责人进行全方位详细讲解，系统介绍了新动力金融科技中心整体规划、产业生态、功能布局、配套服务四大核心板块，作为国家级金融科技示范区核心载体、西城区标杆性城市更新项目，新动力金融科技中心汇聚金融科技、高端服务、科创产业优质资源，集聚海量头部企业与专业服务机构，叠加西城区完善的政策体系、人才储备、科创生态与资本优势，形成了资源密集、业态完善、协同联动的高端产业发展矩阵，全方位展现了平台价值与蓬勃的创新活力。<br /><br />
          此次入驻新动力金融科技中心，是熙诚教育投资发展历程中具有里程碑意义的重要节点。公司作为市属国企平台，将充分放大资源整合、产业链接、全域服务核心优势，打破地域服务局限，面向全国各行业、各类型客户提供专业服务，持续深耕主业、提质增效，不断提升企业核心竞争力与全国品牌影响力。<br /><br />
          <img src={Bg29_3} alt="" width={'100%'}/><br /><br />
          新起点、新征程，新势能、新作为。未来，熙诚教育投资将以此次入驻新址为重要契机，立足高端产业新平台、抢抓全国行业新机遇、聚合全域优质新动能，持续深耕教育服务产业、赋能全行业企业高质量发展。公司将始终秉持国企初心与担当，以更饱满的热情、更务实的作风、更专业的服务开拓全国市场，奋力书写企业规模化、高质量发展的崭新篇章！
        </div>
      </div>
    </>
  )
}

const Detail30 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.06.02</div>
      <div className='detail-news-title'>
        对标先进 深学笃行 <br />
        走进菜百股份参访活动圆满举行
      </div>
      <img className='detail-news-banner' src={Bg30} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          为引导优青干部人才拓宽视野、更新理念，主动借鉴标杆企业的创新机制与管理模式，由西城区国资委主办、熙诚教育投资承办的标杆企业参访——走进菜百股份活动，于5月26日下午举行。<br />
          与常规参访不同，本次活动不再停留于一般性的企业介绍，而是围绕“跨越周期的电商探索”与“人才战略创新实践”两大主题展开。来自区属国企的多位学员共同参与，从企业核心能力和长期主义视角理解菜百的发展逻辑。<br />
          在分享环节，菜百股份总经理助理、电商子公司总经理张梦轩以“跨越周期的电商探索——菜百电商的特色发展之路”为主题，系统讲解了菜百电商在不同市场环境下的应对策略与差异化路径。菜百股份党委书记、董事长谢华萍则围绕“人才筑基 创领未来——菜百股份人才战略核心路径与创新实践”，分享了菜百在人才梯队建设、培养机制及业务实践方面的成熟经验。<br />
          <img src={Bg30_1} alt="" width={'100%'}/><br /><br />
          两大分享紧扣“信息化建设”与“数智赋能、人才筑基”的培训目标，既有战略高度，又有落地案例。通过半天的专项学习及对黄金博物馆的参观，学员对菜百股份在公司治理、数字化转型、人才梯队塑造及供应链精细化管理等方面的实践形成了直观而深入的认知。部分学员结合自身在区属国企的工作实际，与分享嘉宾进行了交流探讨，现场学习氛围浓厚。<br /><br />
          <img src={Bg30_2} alt="" width={'100%'}/><br /><br />
          本次标杆企业参访活动圆满落下帷幕。熙诚教育投资表示，将继续围绕区属国企高质量发展需求，组织更多对标学习与交流活动，助力优青干部人才转变思维、开阔眼界，为推动西城区国资国企提质增效、转型升级提供有力支撑。
        </div>
      </div>
    </>
  )
}

const Detail31 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.06.22</div>
      <div className='detail-news-title'>
        2026年西城区国资委系统积极分子（发展对象）培训班举办：严把党员发展“入口关”，锻造国企后备生力军
      </div>
      <img className='detail-news-banner' src={Bg31} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          6月15日，2026年西城区国资委系统积极分子（发展对象）培训班在新动力金融科技中心举办。本次培训由西城区国资委党委主办、熙诚教育投资承办，来自区国资系统各直属党组织的积极分子和发展对象参加。<br /><br />
          集中培训为期三天，学员围绕《学好新党章 奋进新征程》《中国共产党百年光辉历程与启示》《牢固树立和践行正确政绩观，立足本职岗位，争取早日成为合格的党员》等专题，系统学习了党的二十大精神、习近平总书记关于党的建设的重要思想，进一步掌握党的基本理论、基本路线和基本纲领。<br /><br />
          除集中授课外，全体学员还走进北京金融科技中心现场参观交流，在实地观摩中感悟初心使命、坚定理想信念。<br /><br />
          <img src={Bg31_1} alt="" width={'100%'}/><br /><br />
          培训期间，学员们以饱满的热情投入各项课程，严格遵守纪律、认真聆听讲授、积极参与研讨，展现出优良的组织纪律意识和学习风貌。<br /><br />
          大家纷纷表示，通过此次培训，对党的性质、宗旨和纲领有了更加全面深刻的认识，对发展党员工作程序有了更加清晰的把握，进一步端正了入党动机、增强了入党的自觉意识，今后将立足本职岗位，以实际行动积极向党组织看齐。<br /><br />
          <img src={Bg31_2} alt="" width={'100%'}/><br /><br />
          <img src={Bg31_3} alt="" width={'100%'}/><br /><br />
          下一步，西城区国资委党委将继续从严从实抓好党员队伍建设，持续做好入党积极分子和发展对象的培养教育工作，不断提高后备党员质量，为区属国有企业高质量发展提供坚强组织保证。
        </div>
      </div>
    </>
  )
}

const Detail32 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.07.06</div>
      <div className='detail-news-title'>
        淬炼实干底色 激扬国企力量丨2026年西城区属国企优青人才系列培训圆满收官
      </div>
      <img className='detail-news-banner' src={Bg32} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          近日，由西城区国资委主办、熙诚教育投资承办的2026年国企优青干部人才培训班顺利落下帷幕。本次培训自4月28日启动，历时两个月，覆盖28名近两年参与跨企业交流挂职的优青干部，旨在以系统化培养为青年骨干成长蓄力赋能。<br /><br />
          推动跨企业交流挂职，是西城区国资系统畅通人才双向流动、促进经验互通的重要机制。它打破了企业间的资源壁垒，让经营管理、科技创新、城市运营等不同领域的骨干人才有机会在多岗位历练中拓宽视野、积累复合经验。<br /><br />
          两个月的培养，在形式与内容上都做出了积极探索。青年干部从一场串联五四运动历史地标的骑行研学出发，在行走中追溯红色根脉，完成了一次生动的理想信念教育。<br /><br />
          <img src={Bg32_1} alt="" width={'100%'}/><br /><br />
          走进蓟城智造、菜百股份、广安控股等区属标杆企业的实地参访，则让学员们近距离对标“科技创新、数字化转型、人才梯队建设以及城市品牌打造”等方面的前沿实践，为各自岗位工作打开了新思路。<br /><br />
          <img src={Bg32_2} alt="" width={'100%'}/><br /><br />
          集中授课环节紧扣履职能力提升这一主线，内容覆盖调研方法、廉洁自律、数字化转型、领导力等多个维度，其中部分课程由国资系统内训师担纲授课，兼顾了理论深度与业务实战的衔接。<br /><br />
          <img src={Bg32_3} alt="" width={'100%'}/><br /><br />
          从思想淬炼、视野拓展到本领锻造，项目将三个成长维度有机串联，让挂职青年干部在实践历练之外，同步获得了一次系统化的能力充电。未来，国企优青人才不仅需要通过岗位历练积累实战经验，更需要筑牢思想根基、拓宽思维格局，方能成长为推动国资国企高质量发展的中坚力量。<br /><br />
          结营并非终点，区国资委将持续完善“选、育、管、用”全链条人才培育体系，把干部培养、岗位交流、能力提升贯通于人才工作的全过程。<br /><br />
          熙诚教育投资深度参与了培训的全过程，此次将红色研学、标杆参访、集中授课有机融合的培训实践，正是其服务区属国资人才队伍建设、践行“为世界打造中国式企业管理典范”愿景的又一次扎实注脚。
        </div>
      </div>
    </>
  )
}

const Detail33 = () => {
  return (
    <>
      <div className='detail-news-date'>2026.07.31</div>
      <div className='detail-news-title'>
        淬炼财务思维，锻造复合型后备人才梯队
      </div>
      <img className='detail-news-banner' src={Bg33} />
      <div className='detail-news-block'>
        <div className='detail-news-desc'>
          7月28日，金融街资本第二期复合应用型后备人才培养计划2026年第三次线下集中培训顺利举行。熙诚教育投资为本次培训提供课程设计与组织实施服务，红鑫领航英才班、红鑫强基先锋班、红鑫铸魂薪火班共有80余名学员参加。<br /><br />
          <img src={Bg33_1} alt="" width={'100%'}/><br /><br />
          整场培训以“洞见·增长：数字背后的商业真相”为主题，熙诚教育投资特邀财务管理实战领域专家授课，围绕非财务管理人员最关心的经营决策问题展开系统教学。组织形式上，不仅设计了“主修+选修”机制，更面向“管理、党建、门店”三大序列按需开放选课通道，让不同岗位的后备人才根据自身需求自主充电，实现靶向施训、分类赋能。<br /><br />
          “业务合同需要财务审核吗？”“预算应该由谁编制？”“成本管控的责任到底在谁？”课程伊始，讲师以一组贴近实际工作场景的问题切入，迅速引发热烈讨论。结合金融街资本后备人才的岗位特点，本次教学着重破除“财务只是记账算账”的认知误区，帮助学员认识到90%的企业财务结果来源于业务本身。<br /><br />
          随后，讲师围绕“财务底层逻辑、成本费用管控、全面预算管理、财务风险防控”四大模块展开教学，通过大型企业合并报表拆解、经营杠杆分析等实战案例，引导学员跳出“财务是财务部的事”的思维定式，建立“每一笔业务动作都产生财务结果”的经营意识。学员们纷纷表示，一天的课程干货密集、针对性强，从报表解读到风控意识，真正做到了带着问题来、拿着方法回，对今后立足岗位、推动业财融合有了更清晰的思路。<br /><br />
          <img src={Bg33_2} alt="" width={'100%'}/><br /><br />
          下一步，熙诚教育投资将持续深耕企业人才培训领域，以“红鑫”系列人才计划为抓手，在课程研发、形式创新、过程管控等方面持续发力，以更精准、更专业的服务助力客户锻造高素质复合型人才队伍。<br /><br />
        </div>
      </div>
    </>
  )
}